import I18N from 'i18n-js';
const I18n = window.I18n || I18N;
I18n.translations || (I18n.translations = {});
I18n.translations["es"] = I18n.extend((I18n.translations["es"] || {}), {
  "activerecord": {
    "attributes": {
      "data_entity": {
        "keys": {
          "address": "Dirección",
          "address_state": "Estado/Provincia",
          "appointments": "Cita",
          "assigned_manager_id": "Reclutador asignado",
          "attachments": "Archivo adjunto",
          "campaign_id": "Campaña",
          "completion_date": "Completado en",
          "country_short_code": "País",
          "created_at": "Agregado en",
          "education": "Educación",
          "email": "Correo electrónico",
          "first_name": "Nombre",
          "gender": "Género",
          "geolocation": "Geolocalización\n",
          "graduation_year": "Año de graduación",
          "labels": "Etiquetas",
          "last_assigned_at": "Fecha de Última Asignación",
          "last_interaction": "Última interacción del Candidato",
          "last_name": "Apellidos",
          "location": "Ubicación",
          "scheduled_at": "Fecha Entrevista",
          "school_name": "Colegio",
          "source": "Fuente del Candidato",
          "talkscore_active_listening": "Escucha Activa TalkScore",
          "talkscore_answer_count": "Cantidad de respuestas de TalkScore",
          "talkscore_cefr": "TalkScore MCER / CEFR",
          "talkscore_comprehension": "Comprensión TalkScore / Escucha activa del inglés",
          "talkscore_fluency": "Fluidez TalkScore",
          "talkscore_generated_at": "Talkscore Generado en",
          "talkscore_grammar": "Gramática TalkScore",
          "talkscore_overall": "TalkScore General ",
          "talkscore_pronunciation": "Pronunciación TalkScore",
          "talkscore_question_count": "Cantidad de preguntas de TalkScore",
          "talkscore_scored_count": "Cantidad de calificaciones de TalkScore",
          "talkscore_vocab": "Vocabulario TalkScore",
          "user_country_code": "Código de Teléfono de  país",
          "user_phone_number": "Celular",
          "years_of_exp": "Años de experiencia laboral"
        }
      },
      "document/tag": {
        "permission": {
          "assigned_manager": "Restringido",
          "owner": "Propietario Acceso Admin",
          "public": "Acceso completo"
        }
      },
      "smart_call/setting": {
        "scenario": {
          "custom_calls": "Llamadas personalizadas",
          "document_request": "Solicitud de documento",
          "engagement_calls_for_passive_candidates": "Convocatorias de compromiso para candidatos pasivos",
          "feedback_collection": "Recogida de comentarios",
          "interview": "Entrevista",
          "job_fair_and_event_invitation": "Invitación a ferias de empleo y eventos",
          "offer_extension": "Oferta de extensión",
          "on_site_interview_invitation": "Invitación a entrevista en el sitio",
          "onboarding_information": "Información de incorporación",
          "rejection_notification": "Notificación de rechazo",
          "reminder": "Recordatorio",
          "status_update": "Actualización de estado"
        }
      }
    },
    "models": {
      "candidate/attribute": "Atributos de Candidato",
      "prompt/set": "Conjunto de preguntas",
      "workflow": "Flujo automático"
    }
  },
  "autoflow": {
    "add": "Añadir",
    "edit": "Editar",
    "next": "Siguiente",
    "operations": {
      "status": {
        "started": "Iniciado"
      }
    },
    "operators": {
      "or": "O"
    },
    "status": {
      "title": "Estado"
    }
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Trabajo de Facebook guardado con éxito"
      },
      "google": {
        "fill_out": "Complete todos los datos requeridos en la Configuración de la campaña",
        "save_success": "Google Jobs se guardó correctamente"
      },
      "landing_page": {
        "add_url": "Agregar un URL",
        "cancel": "Cancelar",
        "custom_landing_page_description": "Genere nuevas URL y asigne una fuente por URL. Los candidatos que completen la preselección en la URL serán rastreados con la fuente personalizada. Los nombres de fuentes comunes son el nombre del sitio y el nombre del reclutador asignado, el nombre del evento.",
        "custom_landing_page_title": "Personalizar la fuente de la página de destino",
        "custom_source_label": "Nombre de la Fuente",
        "date_created": "Creada",
        "invalid_url": "URL de redireccionamiento no válido",
        "landing_pages": "Páginas de destino",
        "landing_pages_desc": "Por defecto, la página de destino se registra como \"Landing Page\" en el punto de datos de origen. Abajo, puede nombrar una URL de página de destino como fuente personalizada.",
        "redirect_after": "Redirigir Después",
        "redirect_url": "Enlace de redireccionamiento",
        "refresh_rate_min_error": "La frecuencia de actualización debe ser de al menos 1 segundo",
        "reload_redirect": "Redirigir Después",
        "save_success": "La página de destino se guardó con éxito",
        "seconds": "Segundos",
        "source_placeholder": "Ej. Sitio en Washington ",
        "source_title": "Fuente Personalizada",
        "url_copy": "URL copiada al portapapeles"
      },
      "messenger": {
        "copy_url": "Copiar URL",
        "create_messenger_source_url": "Crear URL",
        "create_messenger_source_url_success": "URL de Messenger fue creado exitosamente",
        "default_input_source_value": "Fuente",
        "default_select_option_value": "Seleccionar...",
        "facebook_pages": "Páginas de Facebook",
        "messenger_link": "Link de Messenger",
        "messenger_source_url_description": "Los candidatos que usen este URL de Messenger serán rastreados con esta fuente.",
        "messenger_source_url_title": "Rastrear fuente personalizada en un URL de Messenger",
        "page_title": "Pagina de Facebook",
        "previously_created_messenger_urls": "URLs de Messenger creados previamente",
        "previously_created_messenger_urls_description": "Aquí están todos los URL de Messenger creados previamente para esta campaña",
        "select_pages": "Seleccione las páginas de Facebook que le gustaría que muestren esta campaña en Messenger. Luego, haga clic en \"Guardar\" para aplicar los cambios",
        "source_label": "Fuente",
        "source_title": "Rastrea una fuente personalizada"
      },
      "tecoloco_jobs": {
        "fill_out": "Complete todos los datos requeridos en la Configuración de la campaña",
        "save_success": "Trabajos de Tecoloco guardados con éxito"
      }
    }
  },
  "campaigns": {
    "edit": {
      "campaign_types": {
        "all": "Todas las campañas"
      },
      "contract_type": {
        "options": {
          "internship": "Practicas",
          "permanent": "Permanente",
          "temporary": "Temporal"
        },
        "title": "Tipo de contrato"
      },
      "form": {
        "exit_interview": "Entrevista de salida",
        "inquiry": "Consulta",
        "job_application": "Solicitud de empleo",
        "job_template": "Plantilla",
        "job_type": "Tipo de Posición",
        "job_type_options": {
          "contract": "Contrato",
          "fixed_term": "Término fijo",
          "full_time": "Tiempo Completo",
          "internship": "Practicas",
          "part_time": "Medio Tiempo",
          "probationary": "De prueba",
          "project": "Proyecto",
          "regular": "Regular",
          "seasonal": "Estacional",
          "volunteer": "Voluntarios"
        },
        "location": "Ubicación",
        "onboarding": "Incorporación",
        "salary": "Salario",
        "single_engagement": "Comunicación de una sola vez",
        "type": "Tipo de campaña"
      },
      "job_category": {
        "options": {
          "accounting_auditing": "Contabilidad/Auditoría",
          "administrative": "Administrativo",
          "aerospace_engineering": "Ingeniería aeroespacial",
          "architecture": "Arquitectura",
          "aviation": "Aviación",
          "building_supplies_retail": "Venta al por menor de suministros de construcción",
          "cleaning": "Limpieza",
          "coaching": "Coaching",
          "consultancy": "Consultoría",
          "creative": "Creativo",
          "customer_service": "Atención al cliente",
          "design": "Diseño",
          "driving_transport": "Conducción/Transporte",
          "education": "Educación",
          "engineering": "Ingeniería",
          "finance": "Finanzas",
          "food_kitchen": "Alimentación/Cocina",
          "healthcare": "Sanidad",
          "human_resources": "Recursos Humanos",
          "insurance": "Seguros",
          "it": "TI",
          "journalism": "Periodismo",
          "legal": "Legal",
          "management": "Gestión",
          "marketing": "Marketing",
          "operations": "Operaciones",
          "planning_logistics": "Planificación/Logística",
          "politics_policies": "Política",
          "pr_communications": "Relaciones públicas y comunicación",
          "procurement": "Adquisiciones",
          "property": "Propiedad",
          "quality_management": "Gestión de la calidad",
          "recruitment": "Contratación",
          "retail": "Venta al por menor",
          "sales": "Ventas",
          "science_and_research": "Ciencia e investigación",
          "skilled_work": "Trabajo cualificado",
          "social_work": "Trabajo social",
          "technology": "Tecnología",
          "translations": "Traducciones",
          "urban_planning": "Urbanismo"
        },
        "title": "Función"
      },
      "job_industry": {
        "options": {
          "academic": "Académico",
          "accounting": "Contabilidad",
          "advertising": "Publicidad",
          "aerospace": "Aeroespacial",
          "agriculture": "Agricultura",
          "arts_and_culture": "Arte y cultura",
          "automotive": "Automoción",
          "aviation": "Aviación",
          "banking": "Banca",
          "building_and_construction": "Edificación y construcción",
          "charity_and_not_for_profit": "Organizaciones benéficas y sin ánimo de lucro",
          "chemical": "Química",
          "communications": "Comunicaciones",
          "defence_and_military": "Defensa y militar",
          "e_commerce": "Comercio electrónico",
          "education": "Educación",
          "energy": "Energía",
          "engineering": "Ingeniería",
          "entertainment": "Entretenimiento",
          "facility_management": "Gestión de instalaciones",
          "fashion": "Moda",
          "fast_moving_consumer_goods": "Bienes de consumo de rápida rotación",
          "finance": "Finanzas",
          "food": "Alimentación",
          "generic": "Genérico",
          "government_and_public_sector": "Gobierno y sector público",
          "health_and_safety": "Salud y seguridad",
          "healthcare": "Sanidad",
          "hospitality": "Hostelería",
          "information_technology": "Tecnologías de la información",
          "insurance": "Seguros",
          "language": "Idioma",
          "legal": "Legal",
          "leisure_and_sport": "Ocio y deporte",
          "logistics_and_supply_chain": "Logística y cadena de suministro",
          "manufacturing": "Fabricación",
          "maritime": "Marítimo",
          "media": "Medios de comunicación",
          "mining": "Minería",
          "multilingual": "Multilingüe",
          "pharmaceuticals": "Productos farmacéuticos",
          "property_and_housing": "Propiedad y vivienda",
          "real_estate": "Inmobiliario",
          "recruitment": "Contratación",
          "retail": "Venta al por menor",
          "science_and_research": "Ciencia e investigación",
          "sustainability": "Sostenibilidad",
          "telecommunications": "Telecomunicaciones",
          "transport_and_rail": "Transporte y ferrocarril",
          "travel_and_tourism": "Viajes y turismo"
        },
        "title": "Industria"
      },
      "new_applications_status": {
        "closed": "Cerrada a nuevas solicitudes",
        "receiving": "Recibiendo nuevas solicitudes"
      }
    },
    "folders": {
      "all": "Todas las carpetas",
      "completed": {
        "title": "Completado"
      },
      "hired": {
        "title": "Contratados"
      },
      "no_response": {
        "title": "Sin Respuesta"
      },
      "on_hold": {
        "title": "Lista de espera"
      },
      "pending": {
        "title": "Buzón"
      },
      "rejected": {
        "title": "Rechazados"
      },
      "shortlisted": {
        "title": "Preseleccionados"
      }
    },
    "message": {
      "tabs": {
        "completion": {
          "form": {
            "preview": "Vista previa"
          }
        }
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Compartir"
        }
      },
      "state": {
        "pending": "En cola"
      }
    },
    "buttons": {
      "proceed": "Proceder",
      "submit": "Envíar"
    },
    "filters": {
      "location": "Ubicación",
      "search_campaigns": "Buscar campañas"
    },
    "labels": {
      "completed": "Completado"
    },
    "menu": {
      "copy": "Copiar"
    },
    "modals": {
      "confirm_your_action": "Confirme su acción",
      "continue": "Continuar"
    },
    "notice": {
      "candidate": {
        "one": "candidato",
        "other": "candidatos"
      }
    },
    "options": {
      "deleted": "Eliminados",
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATSAPP"
    },
    "toastr": {
      "actions": {
        "background": "Esta acción se está procesando en segundo plano.",
        "failed": "Esta acción no se procesó correctamente.",
        "success": "Esta acción se procesó correctamente."
      }
    },
    "upload": "Subir"
  },
  "companies": {
    "settings": {
      "buttons": {
        "delete": "Eliminar"
      },
      "folder_settings": {
        "destroy": {
          "confirm": "Está a punto de eliminar %{folder}. Después de eliminar, ya no será visible en las campañas. ¿Desea continuar?",
          "success": "La carpeta fue eliminada exitosamente"
        }
      },
      "team": {
        "email_address_label": "Dirección de correo electrónico",
        "phone_number_label": "Número de teléfono",
        "role_permissions": {
          "manager": "Administrador"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "dom",
      "lun",
      "mar",
      "mié",
      "jue",
      "vie",
      "sáb"
    ],
    "abbr_month_names": [
      null,
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic"
    ],
    "day_names": [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%-d/%-m/%Y",
      "long": "%-d de %B de %Y",
      "short": "%-d de %b"
    },
    "month_names": [
      null,
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "alrededor de 1 hora",
        "other": "alrededor de %{count} horas"
      },
      "about_x_months": {
        "one": "alrededor de 1 mes",
        "other": "alrededor de %{count} meses"
      },
      "about_x_years": {
        "one": "alrededor de 1 año",
        "other": "alrededor de %{count} años"
      },
      "almost_x_years": {
        "one": "casi 1 año",
        "other": "casi %{count} años"
      },
      "half_a_minute": "medio minuto",
      "less_than_x_minutes": {
        "one": "menos de 1 minuto",
        "other": "menos de %{count} minutos"
      },
      "less_than_x_seconds": {
        "one": "menos de 1 segundo",
        "other": "menos de %{count} segundos"
      },
      "over_x_years": {
        "one": "más de 1 año",
        "other": "más de %{count} años"
      },
      "x_days": {
        "one": "1 día",
        "other": "%{count} días"
      },
      "x_minutes": {
        "one": "1 minuto",
        "other": "%{count} minutos"
      },
      "x_months": {
        "one": "1 mes",
        "other": "%{count} meses"
      },
      "x_seconds": {
        "one": "1 segundo",
        "other": "%{count} segundos"
      }
    },
    "prompts": {
      "day": "Día",
      "hour": "Hora",
      "minute": "Minutos",
      "month": "Mes",
      "second": "Segundos",
      "year": "Año"
    }
  },
  "eos": {
    "campaign": {
      "applicant_scoring": {
        "applicant_scoring": {
          "add": "Añadir",
          "candidate_attribute": "Atributo del candidato",
          "description": "Seleccione Atributos de Candidato y asigne un porcentaje de peso a cada uno para un total del 100% para la Afinidad al puesto de esta campaña.",
          "dropdown_hint": "Seleccione un atributo de la lista\n",
          "title": "Afinidad al puesto",
          "weight": "Peso"
        },
        "description": "Configure reglas de afinidad al puesto para esta campaña asignando un peso a cada Atributo de Candidato (Geolocalización, Nivel de Inglés de TalkScore y preguntas de Opción Múltiple), y luego configure una puntuación para los elemento dentro de esos parámetro. ",
        "error": "La configuración no se guardó. Por favor intente de nuevo. ",
        "item_scoring": {
          "candidate_attribute": "Atributo del candidato",
          "description": "Configure un parámetro de calificación para cada elemento de 0 a 100%. En este caso, un 100% significa que un candidato con ese parámetro obtendrá la puntuación total asignada en. la pestaña de Afinidad al puesto. ",
          "empty": "Aún no se han configurado Atributos de Candidato. Agregue atributos y asígneles un peso primero en la pestaña de Calificación. ",
          "hint": {
            "geolocation": "Distancia de la ubicación de Campaña configurada en Ajustes. ",
            "multiple": "Para editar estos elementos debe ingresar a la pestaña de Preguntas y modificar las opciones directamente. ",
            "talkScore": ""
          },
          "items": "Elementos y Parámetros de Calificación",
          "title": "Calificación de ítems",
          "value_label": {
            "geopoint": "Dentro de"
          }
        },
        "shared": {
          "cancel": "Cancelar",
          "candidate": "Atributo del candidato",
          "save": "Guardar"
        },
        "success": "La Afinidad al puesto se guardó con éxito. ",
        "title": "Afinidad al puesto",
        "weight_error": "La distribución del peso debe sumar 100%"
      },
      "label": {
        "actions": {
          "activate": {
            "body": "¿Estás seguro de que deseas activar esta campaña?",
            "title": "Activar campaña"
          },
          "archive": {
            "body": "¿Estás seguro de que deseas archivar esta campaña?",
            "title": "Campaña de archivo"
          },
          "bulk_archive": {
            "body": "¿Está seguro de que desea archivar estas campañas?",
            "title": "Archivo de campañas"
          },
          "close": {
            "body": "¿Está seguro de que desea detener las solicitudes para esta campaña?",
            "title": "Detener aplicaciones"
          },
          "duplicate": {
            "body": "¿Estás seguro de que deseas duplicar esta campaña?",
            "title": "Campaña duplicada"
          },
          "export": {
            "body": "¿Está seguro de que desea exportar esta campaña?",
            "title": "Campaña de exportación"
          },
          "favorite": {
            "body": "¿Estás seguro de que deseas añadir esta campaña a favoritos?",
            "title": "Añadir a favoritos"
          },
          "open": {
            "body": "¿Está seguro de que desea permitir aplicaciones para esta campaña?",
            "title": "Permitir aplicaciones"
          },
          "unfavorite": {
            "body": "¿Estás seguro de que deseas eliminar esta campaña de favoritos?",
            "title": "Eliminar de favoritos"
          }
        },
        "add_button": "Agregar un botón",
        "add_candidates": "Agregar candidatos",
        "add_question_set": "Agregar un Set de Preguntas",
        "autoflow": "Flujo automático",
        "banner": "Banner\n",
        "call_to_action": "Llamado a la Acción",
        "campaign_types": {
          "exit_interview": "Entrevista de salida",
          "inquiry": "Consulta",
          "job_application": "Solicitud de empleo",
          "job_template": "Plantilla",
          "onboarding": "Incorporación",
          "single_time_engagement": "Difusión",
          "unassigned": "Sin asignar"
        },
        "cancel": "Cancelar",
        "candidates": "Candidatos",
        "categories": {
          "active": "Activo",
          "archived": "Archivado",
          "closed": "Cerrado"
        },
        "clear_filters": "Borrar filtros",
        "clear_selection": "Borrar selección",
        "closed_campaigns": "Campañas cerradas",
        "completion_message": "Mensaje de Finalización\n",
        "copy": "Copiar",
        "create_button": "Crear botón",
        "created_at": "Creado en",
        "created_at_by": "Creado el %{date} por %{user}",
        "crop": "Recortar",
        "expected_csv_columns": "Columnas CSV previstas",
        "explore_leads": "Explorar candidatos",
        "facebook_pixel_id": "ID de Facebook Pixel ",
        "favorite": "Favorito",
        "favorites": "Favoritos",
        "google_tag_container_id": "ID del contenedor del administrador de etiquetas de Google",
        "job_category": "Categoría de empleo",
        "job_matching": "Afinidad al puesto",
        "job_profile": "Perfil del puesto",
        "landing_page_type": "Tipo de Página de Destino",
        "landing_page_url": "URL del Landing Page",
        "last_activity": {
          "custom": "Personalizado",
          "last_30_days": "Últimos 30 días",
          "last_7_days": "Últimos 7 días",
          "last_90_days": "Últimos 90 días",
          "title": "Última actividad",
          "today": "Hoy"
        },
        "main_settings": "Configuración de campaña",
        "new_landing_page_design": "Nueva Página de Destino",
        "onboarding_questions": "Preguntas de inducción",
        "prescreening_questions": "Preguntas de preselección",
        "published_on": "Publicado en",
        "redirect_url": "Enlace de redireccionamiento",
        "see_all": "Ver todos",
        "select_all_campaigns_count": "Campañas seleccionadas %{count}",
        "select_multiple_campaigns": "Seleccionar varias campañas",
        "selected_all_current_filters": "Seleccionadas todas las campañas %{count} con los filtros actuales",
        "showing_all_results": "Mostrando todos los resultados de %{count}",
        "text_displayed": "Texto desplegado",
        "unfavorite": "Quitar de favoritos"
      },
      "talkscore": {
        "weight_distribution": {
          "description": "TalkScore permite calificar respuestas de audio en inglés. Se calcula usando 5 elementos: Fluidez, Gramática, Pronunciación, Vocabulario y Relevancia. Respuestas no relevantes no serán consideradas de manera automática. Aquí se puede modificar el peso de los primeros 4 factores para reflejar sus prioridades y preferencias.",
          "error": "La configuración de TalkScore no se guardó. Por favor intente de nuevo.",
          "subtitle": "Parámetros de Calificación",
          "success": "La configuración de TalkScore se guardó con éxito. ",
          "title": "Calificación de inglés"
        }
      },
      "text": {
        "active_cta_limit": "Se alcanzó el límite de botones activos. ",
        "add_cta": "Agregar botones de Llamado a la Acción a la Pantalla de Finalización",
        "add_cta_info": "Botones de Llamado a la acción en las Pantallas de finalización y así redirigir a los aplicantes a tus redes sociales o para realizar una acción. Puedes crear múltiples botones, pero solo tres pueden estar activos a la vez. ",
        "allowed_banner_files": "Tipos de archivos permitidos: jpg, png, jpeg. %{file_size} Máx.",
        "apply_new_design": "Aplicar la nueva Página de Destino a esta campaña. ",
        "banner_notice": "Estás utilizando el Banner predeterminado en todas las campañas desde la Configuración de la Empresa. ",
        "banner_required": "Este campo es requerido.",
        "button_limit_reached": "Se alcanzó el límite de botones activos.",
        "click_on_dropdown": "Haz clic en el menú desplegable para leer más sobre cada tipo.",
        "closed_campaigns_desc": "Esta es una nueva categoría que agrupa campañas donde la opción 'Permitir nuevas postulaciones' está desactivada",
        "custom_source_guide": "Por defecto, la página de destino se registra como \"Landing Page\" en el punto de datos de origen. Abajo, puede nombrar una URL de página de destino como fuente personalizada.",
        "default_banner_use": "Si no se agrega ningún banner y hay un Banner Predeterminado disponible en la Configuración de Empresa, se utilizará el Banner Predeterminado.",
        "delete_set_confirmation": "¿Está seguro de que desea eliminar este conjunto de preguntas de esta campaña?",
        "incomplete_details": "Detalles incompletos.",
        "internal_server_error": "Lo sentimos, estamos experimentando problemas con nuestro servidor. Por favor, inténtelo de nuevo más tarde.",
        "invalid_url": "%{url} no es una URL válida. ",
        "landing_page_type": {
          "multiple": {
            "description": "Se muestran las preguntas una a la vez. ",
            "title": "Una Pregunta por Pantalla"
          },
          "single": {
            "description": "Todas las preguntas se muestran en una sola página. ",
            "title": "Formulario"
          }
        },
        "landing_pages": "Páginas de destino",
        "no_campaigns_found": "No se encontraron campañas",
        "nothing_to_update": "Nada que actualizar.",
        "page_type_notice": "Ya has seleccionado el tipo %{type} para todas las campañas desde Configuración de la Empresa.",
        "question_set_consistency": "Al utilizar un set de preguntas, puede garantizar la consistencia en multiples campañas. Para editarlas, vaya a la pestaña Set de Preguntas en Plantillas.",
        "recommended_banner": "%{width}px x %{height}px recomendado.",
        "response_resubmit": {
          "disabled": "Deshabilite el botón Atrás para evitar reenvíos (no aplicable a las Campañas de Inducción)",
          "enabled": "Habilite el botón Atrás para permitir reenvíos (no aplicable a las Campañas de Inducción)"
        },
        "search_campaigns_by": "Buscar campañas por nombre, puesto de trabajo o palabra clave (ej.: 'Asociado de ventas')",
        "select_multiple_campaigns": {
          "desc1": "Esta opción permite al usuario filtrar Leads mediante selección múltiple en esta vista.",
          "desc2": "Otras opciones como 'Detener nuevas postulaciones' podrían añadirse como opciones para múltiples campañas."
        },
        "select_question_set": "Agregar un Set de Preguntas",
        "selected_number_campaigns": "Campañas seleccionadas %{count}",
        "shown_end_form": "Se muestra al final del formulario.",
        "updated_successfully": "Actualizado con éxito.",
        "view_selected_set_info": "Vea el set de preguntas seleccionado, elimínelo de esta campaña o reemplázelo por otro existente. Para editar las preguntas directamente, vaya a la pestaña de Plantillas de sets de preguntas."
      }
    },
    "candidate": {
      "application": {
        "id": "ID de la aplicación",
        "talkscore": {
          "active_listening": {
            "A0": "Dificultad para entender el inglés hablado, requiriendo frecuentemente repetición y reformulación; lucha significativamente con el habla no ensayada.",
            "A1": "Dificultad para entender el inglés hablado, requiriendo frecuentemente repetición y reformulación; lucha significativamente con el habla no ensayada.",
            "A1+": "Dificultad para entender el inglés hablado, requiriendo frecuentemente repetición y reformulación; lucha significativamente con el habla no ensayada.",
            "A2": "Puede entender el inglés hablado básico, especialmente en situaciones familiares, aunque puede perder matices y significados implícitos.",
            "A2+": "Puede entender el inglés hablado básico, especialmente en situaciones familiares, aunque puede perder matices y significados implícitos.",
            "B1": "Entiende los puntos principales del inglés hablado con alguna dificultad con temas complejos o desconocidos; puede requerir aclaraciones ocasionales con acentos, habla rápida o lenguaje idiomático.",
            "B1+": "Entiende los puntos principales del inglés hablado con alguna dificultad con temas complejos o desconocidos; puede requerir aclaraciones ocasionales con acentos, habla rápida o lenguaje idiomático.",
            "B2": "Puede seguir el habla extendida y líneas complejas de argumentación siempre que el tema sea razonablemente familiar; puede perder algunas sutilezas y referencias culturales.",
            "B2+": "Puede seguir el habla extendida y líneas complejas de argumentación siempre que el tema sea razonablemente familiar; puede perder algunas sutilezas y referencias culturales.",
            "C1": "Exhibe una excelente comprensión del lenguaje hablado incluso cuando involucra habla abstracta, estructuralmente compleja o altamente idiomática.",
            "C1+": "Exhibe una excelente comprensión del lenguaje hablado incluso cuando involucra habla abstracta, estructuralmente compleja o altamente idiomática.",
            "C2": "Exhibe una excelente comprensión del lenguaje hablado incluso cuando involucra habla abstracta, estructuralmente compleja o altamente idiomática."
          },
          "breakdown": "Desglose de puntuación",
          "categories": {
            "active_listening": "Escucha activa",
            "comprehension": "Comprensión",
            "fluency": "Fluidez",
            "grammar": "Gramática",
            "pronunciation": "Pronunciación",
            "vocab": "Vocabulario"
          },
          "comprehension": {
            "A0": "Comprende solo inglés hablado y escrito muy básico con dificultades significativas para entender oraciones.",
            "A1": "Comprende solo inglés hablado y escrito muy básico con dificultades significativas para entender oraciones.",
            "A1+": "Comprende solo inglés hablado y escrito muy básico con dificultades significativas para entender oraciones.",
            "A2": "Puede entender frases y vocabulario de alta frecuencia relacionado con áreas de relevancia personal más inmediata; lucha con textos y discursos complejos.",
            "A2+": "Puede entender frases y vocabulario de alta frecuencia relacionado con áreas de relevancia personal más inmediata; lucha con textos y discursos complejos.",
            "B1": "Puede entender los puntos principales de entradas estándar claras sobre asuntos familiares; puede tener problemas con contenido complejo o abstracto.",
            "B1+": "Puede entender los puntos principales de entradas estándar claras sobre asuntos familiares; puede tener problemas con contenido complejo o abstracto.",
            "B2": "Entiende el razonamiento detallado tanto en el lenguaje hablado como escrito, incluyendo discusiones técnicas en su especialización, aunque puede luchar con  vocabulario desconocido, temas abstractos, implícitos o cargados culturalmente.",
            "B2+": "Entiende el razonamiento detallado tanto en el lenguaje hablado como escrito, incluyendo discusiones técnicas en su especialización, aunque puede luchar con  vocabulario desconocido, temas abstractos, implícitos o cargados culturalmente.",
            "C1": "Comprende casi todo lo que oye o lee con facilidad, incluyendo significados indirectos, figurados e implícitos.",
            "C1+": "Comprende casi todo lo que oye o lee con facilidad, incluyendo significados indirectos, figurados e implícitos.",
            "C2": "Comprende casi todo lo que oye o lee con facilidad, incluyendo significados indirectos, figurados e implícitos."
          },
          "error": {
            "subtitle": "Refresque la página o vuelva a intentarlo más tarde.",
            "title": "¡Ups! Algo salió mal al cargar este informe."
          },
          "fluency": {
            "A0": "El habla es muy lenta y a menudo se interrumpe por la búsqueda de expresiones y formulaciones, lo que lleva a una comunicación desarticulada.",
            "A1": "El habla es muy lenta y a menudo se interrumpe por la búsqueda de expresiones y formulaciones, lo que lleva a una comunicación desarticulada.",
            "A1+": "El habla es muy lenta y a menudo se interrumpe por la búsqueda de expresiones y formulaciones, lo que lleva a una comunicación desarticulada.",
            "A2": "Pueden manejar un discurso simple y ensayado pero luchan para hablar espontáneamente y conectar ideas de manera fluida, resultando en pausas frecuentes.",
            "A2+": "Pueden manejar un discurso simple y ensayado pero luchan para hablar espontáneamente y conectar ideas de manera fluida, resultando en pausas frecuentes.",
            "B1": "Demuestra una fluidez moderada, capaz de mantener una conversación a pesar de alguna vacilación y un flujo de habla desigual.",
            "B1+": "Demuestra una fluidez moderada, capaz de mantener una conversación a pesar de alguna vacilación y un flujo de habla desigual.",
            "B2": "El habla es generalmente fluida con algunas repeticiones o autocorrecciones ocasionales; pero pueden desarrollar ideas espontáneamente y comunicarlas con fluidez.",
            "B2+": "El habla es generalmente fluida con algunas repeticiones o autocorrecciones ocasionales; pero pueden desarrollar ideas espontáneamente y comunicarlas con fluidez.",
            "C1": "El habla es fluida y espontánea con pocas interrupciones o vacilaciones, demostrando un dominio efectivo de las expresiones idiomáticas y un flujo natural.",
            "C1+": "El habla es fluida y espontánea con pocas interrupciones o vacilaciones, demostrando un dominio efectivo de las expresiones idiomáticas y un flujo natural.",
            "C2": "El habla es fluida y espontánea con pocas interrupciones o vacilaciones, demostrando un dominio efectivo de las expresiones idiomáticas y un flujo natural."
          },
          "generated_on": "Generado en",
          "grammar": {
            "A0": "El control gramatical es muy limitado; los errores son omnipresentes y a menudo obstruyen la comprensión.",
            "A1": "El control gramatical es muy limitado; los errores son omnipresentes y a menudo obstruyen la comprensión.",
            "A1+": "El control gramatical es muy limitado; los errores son omnipresentes y a menudo obstruyen la comprensión.",
            "A2": "Muestra algún control sobre estructuras gramaticales básicas, aunque las oraciones complejas suelen ser propensas a errores, a veces impidiendo el significado.",
            "A2+": "Muestra algún control sobre estructuras gramaticales básicas, aunque las oraciones complejas suelen ser propensas a errores, a veces impidiendo el significado.",
            "B1": "La gramática es generalmente correcta para temas familiares al hablante, aunque pueden ocurrir errores en estructuras más complejas o situaciones desconocidas.",
            "B1+": "La gramática es generalmente correcta para temas familiares al hablante, aunque pueden ocurrir errores en estructuras más complejas o situaciones desconocidas.",
            "B2": "Buen control gramatical; los errores ocurren pero generalmente no afectan el significado, y las estructuras complejas son manejadas con cierta confianza.",
            "B2+": "Buen control gramatical; los errores ocurren pero generalmente no afectan el significado, y las estructuras complejas son manejadas con cierta confianza.",
            "C1": "\"Demuestra un fuerte control gramatical; los errores son poco frecuentes y menores, con una clara capacidad para usar formas gramaticales complejas de manera natural.",
            "C1+": "\"Demuestra un fuerte control gramatical; los errores son poco frecuentes y menores, con una clara capacidad para usar formas gramaticales complejas de manera natural.",
            "C2": "\"Demuestra un fuerte control gramatical; los errores son poco frecuentes y menores, con una clara capacidad para usar formas gramaticales complejas de manera natural."
          },
          "overall": {
            "A0": "Este rango indica un dominio mínimo del idioma inglés. Los candidatos dentro de este grupo demuestran dificultades considerables para entender y expresar el inglés básico, limitando su capacidad para comunicarse efectivamente.",
            "A1": "Este rango indica un dominio mínimo del idioma inglés. Los candidatos dentro de este grupo demuestran dificultades considerables para entender y expresar el inglés básico, limitando su capacidad para comunicarse efectivamente.",
            "A1+": "Este rango indica un dominio mínimo del idioma inglés. Los candidatos dentro de este grupo demuestran dificultades considerables para entender y expresar el inglés básico, limitando su capacidad para comunicarse efectivamente.",
            "A2": "Los candidatos que puntúan en este rango poseen un dominio limitado del idioma. Son capaces de entender y comunicar inglés básico en situaciones familiares, pero su competencia no es suficiente para escenarios complejos o menos familiares, limitando su capacidad para comunicarse efectivamente.",
            "A2+": "Los candidatos que puntúan en este rango poseen un dominio limitado del idioma. Son capaces de entender y comunicar inglés básico en situaciones familiares, pero su competencia no es suficiente para escenarios complejos o menos familiares, limitando su capacidad para comunicarse efectivamente.",
            "B1": "Este rango de puntuaciones refleja un nivel de competencia justo en inglés. Los candidatos pueden entender y discutir temas familiares, pero podrían tener dificultades con temas nuevos o hablantes rápidos. La comunicación puede estar afectada por imprecisiones gramaticales, fluidez o pronunciación, lo que puede afectar la comunicación, pero no limitarla.",
            "B1+": "Este rango de puntuaciones refleja un nivel de competencia justo en inglés. Los candidatos pueden entender y discutir temas familiares, pero podrían tener dificultades con temas nuevos o hablantes rápidos. La comunicación puede estar afectada por imprecisiones gramaticales, fluidez o pronunciación, lo que puede afectar la comunicación, pero no limitarla.",
            "B2": "Los candidatos en este rango de puntuaciones tienen un fuerte dominio del idioma inglés. Pueden participar en discusiones extendidas y entender información detallada. Aunque pueden ocurrir errores lingüísticos menores, raramente reducen la efectividad de la comunicación.",
            "B2+": "Los candidatos en este rango de puntuaciones tienen un fuerte dominio del idioma inglés. Pueden participar en discusiones extendidas y entender información detallada. Aunque pueden ocurrir errores lingüísticos menores, raramente reducen la efectividad de la comunicación.",
            "C1": "Este rango de puntuaciones indica un dominio casi nativo del idioma inglés. Los candidatos muestran la capacidad de entender y utilizar el lenguaje complejo de manera fluida y precisa, manejando de manera experta la comunicación avanzada en cualquier entorno.",
            "C1+": "Este rango de puntuaciones indica un dominio casi nativo del idioma inglés. Los candidatos muestran la capacidad de entender y utilizar el lenguaje complejo de manera fluida y precisa, manejando de manera experta la comunicación avanzada en cualquier entorno.",
            "C2": "Este rango de puntuaciones indica un dominio casi nativo del idioma inglés. Los candidatos muestran la capacidad de entender y utilizar el lenguaje complejo de manera fluida y precisa, manejando de manera experta la comunicación avanzada en cualquier entorno."
          },
          "overall_score": "Puntuación general",
          "pronunciation": {
            "A0": "La pronunciación está fuertemente influenciada por la lengua materna de los candidatos, a menudo dificultando la comprensión sin un considerable esfuerzo por parte del hablante y del oyente.",
            "A1": "La pronunciación está fuertemente influenciada por la lengua materna de los candidatos, a menudo dificultando la comprensión sin un considerable esfuerzo por parte del hablante y del oyente.",
            "A1+": "La pronunciación está fuertemente influenciada por la lengua materna de los candidatos, a menudo dificultando la comprensión sin un considerable esfuerzo por parte del hablante y del oyente.",
            "A2": "Los errores de pronunciación son frecuentes y pueden dificultar la comprensión. Aunque las frases y expresiones más básicas generalmente son comprensibles, la comunicaciónnse ve afectada.",
            "A2+": "Los errores de pronunciación son frecuentes y pueden dificultar la comprensión. Aunque las frases y expresiones más básicas generalmente son comprensibles, la comunicaciónnse ve afectada.",
            "B1": "La pronunciación es comprensible para un oyente nativo, aunque el acento y las pronunciaciones erróneas pueden ocasionalmente impedir la comprensión, especialmente en frases complejas o desconocidas.",
            "B1+": "La pronunciación es comprensible para un oyente nativo, aunque el acento y las pronunciaciones erróneas pueden ocasionalmente impedir la comprensión, especialmente en frases complejas o desconocidas.",
            "B2": "Los candidatos pronuncian la mayoría de las palabras correctamente y generalmente son entendidos por los hablantes nativos, a pesar de la influencia ocasional del acento.",
            "B2+": "Los candidatos pronuncian la mayoría de las palabras correctamente y generalmente son entendidos por los hablantes nativos, a pesar de la influencia ocasional del acento.",
            "C1": "La pronunciación es clara y se aproxima mucho a la de un hablante nativo, permitiendo una comunicación fluida y efectiva.",
            "C1+": "La pronunciación es clara y se aproxima mucho a la de un hablante nativo, permitiendo una comunicación fluida y efectiva.",
            "C2": "La pronunciación es clara y se aproxima mucho a la de un hablante nativo, permitiendo una comunicación fluida y efectiva."
          },
          "questions": "Preguntas puntuadas",
          "reading": {
            "likely": {
              "description": "El análisis de voz y los datos de patrones de habla sugieren que el candidato probablemente estaba leyendo un guion. La evaluación está diseñada para evaluar la fluidez oral, por lo que la lectura podría afectar su puntuación. Por favor, revise un breve fragmento de la grabación y considere los resultados con precaución.",
              "title": "Evidencia fuerte de lectura"
            },
            "suspected": {
              "description": "Se encontraron algunos indicios de lectura (p. ej., micropausas frecuentes o una articulación inusualmente precisa). La respuesta aún contiene elementos naturales, pero conviene revisar la grabación antes de basarse en la puntuación de fluidez.",
              "title": "Podría estar leyendo"
            }
          },
          "see_less": "Ver menos",
          "see_more": "Ver más",
          "vocab": {
            "A0": "El rango de vocabulario es muy limitado, restringido a unas pocas frases y palabras memorizadas, insuficientes para conversaciones básicas o para transmitir un significado preciso.",
            "A1": "El rango de vocabulario es muy limitado, restringido a unas pocas frases y palabras memorizadas, insuficientes para conversaciones básicas o para transmitir un significado preciso.",
            "A1+": "El rango de vocabulario es muy limitado, restringido a unas pocas frases y palabras memorizadas, insuficientes para conversaciones básicas o para transmitir un significado preciso.",
            "A2": "El vocabulario es suficiente para conversaciones básicas sobre temas familiares pero carece de diversidad y precisión, limitando la expresión, especialmente en contextos desconocidos.",
            "A2+": "El vocabulario es suficiente para conversaciones básicas sobre temas familiares pero carece de diversidad y precisión, limitando la expresión, especialmente en contextos desconocidos.",
            "B1": "Los candidatos tienen un rango razonable de vocabulario para temas familiares y a veces pueden parafrasear con éxito cuando carecen de vocabulario específico.",
            "B1+": "Los candidatos tienen un rango razonable de vocabulario para temas familiares y a veces pueden parafrasear con éxito cuando carecen de vocabulario específico.",
            "B2": "El rango de vocabulario es amplio y permite discutir una variedad de temas con algunas expresiones detalladas; los errores ocasionales no impiden la comunicación.",
            "B2+": "El rango de vocabulario es amplio y permite discutir una variedad de temas con algunas expresiones detalladas; los errores ocasionales no impiden la comunicación.",
            "C1": "El vocabulario es extenso y matizado, permitiendo a los candidatos expresar ideas complejas y sutiles de manera efectiva y precisa.",
            "C1+": "El vocabulario es extenso y matizado, permitiendo a los candidatos expresar ideas complejas y sutiles de manera efectiva y precisa.",
            "C2": "El vocabulario es extenso y matizado, permitiendo a los candidatos expresar ideas complejas y sutiles de manera efectiva y precisa."
          }
        }
      }
    },
    "company": {
      "label": {
        "color_theme": "Color de Tema",
        "default_banner": "Banner Predeterminado",
        "landing_page_sop_up_screen": "Ventana emergente en la Página de Destino ",
        "primary": "Primario",
        "secondary": "Secundario",
        "shade": "Tono"
      },
      "listings": {
        "button": {
          "cancel": "Cancelar",
          "save": "Guardar",
          "upload": "Cargar"
        },
        "description": "Esta página es donde se muestran las Campañas de Aplicación de Trabajo seleccionadas, lo que permite a los candidatos ver sus ofertas de trabajo y postularse a través de sus respectivas páginas de destino.",
        "employee_referral_program": {
          "are_you_an_employee": "¿Es usted empleado?",
          "desc_1": "Introduzca su dirección de correo electrónico para obtener su enlace de referencia personal para esta página de ofertas de empleo",
          "desc_2": "Una vez enviado, le enviaremos un enlace que podrá compartir con sus amigos. Las referencias son válidas para todos los puestos de trabajo que aparecen aquí",
          "get_link": "Obtener enlace",
          "get_your_referral_link": "Obtenga su enlace de referencia",
          "get_your_referral_link_button": "Obtenga su enlace de referencia",
          "label": {
            "actions": "Acciones",
            "activate": "Activar",
            "created_at": "Creado en",
            "deactivate": "Desactivar",
            "deactivated_at": "Desactivado en",
            "email": "Correo electrónico",
            "erp_job_listing_url": "URL de la lista de empleos ERP",
            "first_name": "Nombre",
            "last_name": "Apellidos",
            "status": {
              "active": "Activo",
              "deactivated": "Desactivado",
              "title": "Estado"
            }
          },
          "no_data": "No hay datos disponibles",
          "refer_a_friend": "Recomendar a un amigo",
          "register_referrer": "Registrarse como remitente",
          "thank_you": {
            "desc_1": "Hemos recibido su correo electrónico: <b>%{email}</b>",
            "desc_2": "Si es correcto, en breve recibirás un correo electrónico con tu enlace de recomendación personal.",
            "desc_3": "Si tiene problemas para recibir su correo electrónico, póngase en contacto con su equipo de RRHH.",
            "desc_4": "¿Necesita hacer algún cambio? Haga clic en <b>Volver</b> para regresar",
            "return": "Devolución",
            "subtitle": "Su enlace de referencia",
            "title": "Gracias!"
          },
          "title": "Programa de referidos",
          "validation": {
            "email_invalid": "Dirección de correo electrónico no válida",
            "email_required": "Correo electrónico obligatorio",
            "first_name_required": "El nombre es obligatorio",
            "last_name_required": "Apellido obligatorio"
          }
        },
        "input": {
          "label": {
            "banner": "Banner",
            "banner_allowed_types": "Tipos de archivos permitidos: jpg, jpeg y png.",
            "banner_recommended_size": "1280px x 400px",
            "copied": "Copiado al portapapeles",
            "header_char_count": "%{count}/60 caracteres",
            "listings_url": "URL de la página de Listado de Vacantes",
            "page_header": "Encabezado de página"
          },
          "placeholder": {
            "page_header": "Buscar ofertas de trabajo en %{company}"
          }
        },
        "messages": {
          "error": "La configuración no se guardó. Por favor intente de nuevo. ",
          "success": "La configuración se guardó correctamente."
        },
        "page": {
          "button": {
            "apply": "Aplicar",
            "first": "Primera",
            "last": "Última",
            "search": "BUSCAR"
          },
          "input": {
            "keywords": "Palabras clave",
            "location": "Ubicación",
            "remote": "Remoto"
          },
          "label": {
            "default_header": "Buscar ofertas de trabajo en %{company}",
            "go_to_top": "Subir",
            "job_count": "Mostrando %{count} de %{total} trabajos",
            "no_results": "No hay resultados",
            "salary_undisclosed": "No revelado"
          },
          "source": "Lista de Vacantes"
        },
        "title": "Listado de Vacantes"
      },
      "meta_settings": {
        "connect_button": "Conectar con WhatsApp",
        "description": "Conecta tu cuenta de WhatsApp Business y gestiona los números de teléfono que Talkpush utiliza para conectar con los candidatos.",
        "destroy_confirmation_dialog": {
          "actions": {
            "cancel": "Cancelar",
            "confirm": "Confirmar"
          },
          "description": "Eliminar este número de teléfono puede interrumpir las conversaciones en curso debido a problemas de conectividad con otros números disponibles. El número no se eliminará de su cuenta de WhatsApp Business.",
          "title": "¿Eliminar este número de teléfono?"
        },
        "feedback": {
          "phone_record_destroy": {
            "error": "Se ha producido un error al eliminar %{phone_number} de Talkpush. Por favor, inténtelo de nuevo.",
            "success": "%{phone_number} ha sido eliminado de Talkpush."
          },
          "phone_record_subscribe": {
            "already_taken_phone_number": "Tu número de WhatsApp ya fue registrado en Talkpush. Ponte en contacto con el servicio de asistencia si necesitas ayuda con la migración.",
            "error": "No hemos podido conectar tu número de WhatsApp. Por favor, inténtalo de nuevo.",
            "locked_phone_number": "Tu número de WhatsApp no puede conectarse porque un PIN de verificación de dos pasos fue configurado previamente. Desactiva la verificación de dos pasos en la aplicación WhatsApp Manager e inténtalo de nuevo.",
            "numberless_whatsapp_account": "Un número de teléfono es requerido para conectar su cuenta de WhatsApp Business a Talkpush. Seleccione una opción de conexión que proporcione un número de teléfono.",
            "success": "Tu número de WhatsApp se conectó correctamente a Talkpush."
          }
        },
        "phone_records_table": {
          "actions": {
            "navigate_to_whatsapp_manager": "Abrir WhatsApp Manager",
            "remove_phone_record": "Eliminar número de teléfono",
            "test_phone_record": "Probar número de teléfono"
          },
          "columns": {
            "last_access_token_update": "Última actualización",
            "owner": "Conectado por",
            "phone_number": "Número de teléfono",
            "quality_rating": "Calificación",
            "status": "Estado",
            "whatsapp_account_name": "Nombre de la cuenta"
          },
          "empty_banner": {
            "description": "Conecta tu cuenta de WhatsApp Business y gestiona los números de teléfono que Talkpush utiliza para conectar con los candidatos.",
            "title": "Conectar la cuenta de WhatsApp Business"
          },
          "error_banner": {
            "action": "Reintentar",
            "description": "No hemos podido obtener tus números de WhatsApp. Por favor, inténtalo de nuevo.",
            "title": "Algo salió mal"
          },
          "fallback_values": {
            "country": "País desconocido",
            "last_access_token_update": "Desconocida",
            "owner": "Desconocido",
            "phone_number": "Desconocido",
            "whatsapp_account_name": "Desconocido"
          },
          "values": {
            "quality_rating": {
              "high": "Alta",
              "low": "Baja",
              "medium": "Media",
              "unknown": "Desconocida"
            },
            "status": {
              "connected": {
                "description": {
                  "healthy": "El número de teléfono asociado funciona correctamente."
                },
                "label": "Conectado"
              },
              "disabled": {
                "description": {
                  "disabled_in_talkpush": "Este número de teléfono fue desactivado manualmente. El envío de mensajes está bloqueado hasta que se vuelva a habilitar en la sección de números de teléfono.",
                  "unhealthy_access_token": "El token de acceso para este número de teléfono no es válido. Conecta el número de teléfono nuevamente para restaurar las capacidades de mensajería.",
                  "unhealthy_meta_status": "Este número ya no está conectado a Meta. Por favor, comprueba la configuración de tu cuenta de WhatsApp Business."
                },
                "label": "Deshabilitado"
              },
              "unknown": {
                "description": {
                  "unknown": "No se puede determinar el estado del número de teléfono en función de la información disponible. Conecta el número de teléfono nuevamente para actualizar el estado."
                },
                "label": "Desconocido"
              }
            }
          }
        },
        "title": "WhatsApp Business"
      },
      "text": {
        "apply_new_design": "Aplicar la nueva Página de Destino a todas las campañas.",
        "apply_page_type": "Aplicar el Tipo de Página de Destino a todas las campañas. Si se selecciona, la opción de modificar el tipo estará deshabilitada en la configuración de la campaña. ",
        "default_banner": "Si no se carga ningún banner en una campaña, se utilizará el Banner Predeterminado.",
        "default_banner_use": "Utilizar el Banner Predeterminado en todas las campañas. Si se selecciona, la opción se desactivará en la configuración de la campaña.",
        "enter_custom_color": "Alternativamente, puede ingresar valores de código HEX en los campos de texto Principal y Secundario.",
        "landing_page_sop_up_screen": "Esto se mostrará como una ventana emergente en las Páginas de Destino antes de que los candidatos ingresen su información personal.",
        "select_color_palette": "Seleccione los colores para el tema de color de la página de destino usando la paleta y los controles deslizantes a continuación."
      }
    },
    "document": {
      "tag": {
        "edit": {
          "click_here": "Haga clic aquí.",
          "click_here_url": "https://help.talkpush.com/es",
          "description": "Configure documentos para reconocimiento, validación de propiedad y extracción de datos para atributos de candidatos existentes. ¿Quiere saber más?",
          "error": "Ocurrió un error. Por favor inténtelo de nuevo.",
          "success": "El documento se actualizó correctamente.",
          "title": "Editar documento"
        },
        "form": {
          "country": {
            "description": "Seleccione qué país emite el documento.",
            "title": "País de Emisión"
          },
          "data_extraction": {
            "attribute": "Atributos de Candidato",
            "data_point": "Punto de dato",
            "description": "Extraiga puntos de datos del documento y guárdelos en un atributo candidato.",
            "title": "Extracción de datos"
          },
          "document_status": {
            "description": "Todos los posibles estados de los documentos y su significado.",
            "failed": {
              "description": "Hubo un error de procesamiento.",
              "title": "Falló"
            },
            "recognized": {
              "description": "El tipo de documento coincide con lo solicitado.",
              "title": "Reconocido"
            },
            "title": "Estado del documento",
            "unrecognized": {
              "description": "El tipo de documento no coincide con lo solicitado o era ilegible.",
              "title": "No reconocido"
            },
            "unverified": {
              "description": "El nombre no coincide con el nombre del candidato o era ilegible.",
              "title": "No verificado"
            },
            "verified": {
              "description": "El tipo de documento coincide con lo solicitado y el nombre coincide con el nombre del candidato.",
              "title": "Verificado"
            }
          },
          "feedback": {
            "description": "Los candidatos reciben comentarios en tiempo real sobre su estado de reconocimiento. Si está activo, los candidatos serán redirigidos al Landing Page para enviar sus documentos.",
            "title": "Retroalimentación en Tiempo Real en el Landing Page\n"
          },
          "identity_verification": {
            "description": "Validar si el nombre que figura en el documento pertenece al candidato.",
            "title": "Verificación de identidad"
          },
          "name": {
            "description": "Este nombre se utiliza para identificar el documento para su reconocimiento y extracción de datos.",
            "title": "Nombre oficial del documento"
          },
          "permissions": {
            "assigned_manager": "Solo los administradores de incorporación pueden ver y descargar",
            "owner": "Los propietarios pueden ver y descargar documentos",
            "public": "Cualquiera con acceso a la Campaña puede ver y descargar",
            "title": "Permisos"
          },
          "recognition": {
            "description": "Validar si el tipo de documento coincide con lo solicitado.",
            "title": "Reconocimiento de documentos"
          }
        },
        "list": {
          "add": "Agregar documento",
          "description": "Gestione los documentos que le gustaría recopilar de los candidatos aquí. Cuando solicite documentos utilizando esta lista, los documentos del candidato se asignarán al tipo de documento correcto que haya especificado aquí.",
          "identitiy_verification": {
            "configured": "Configurado",
            "not_configured": "No configurado"
          },
          "learn_more": "Aprende más.",
          "learn_more_url": "https://help.talkpush.com/es",
          "no_results": "No hay resultados",
          "search": "Buscar documento por nombre o país",
          "subtitle": "Reconocimiento de documentos y extracción de datos.",
          "table": {
            "data_extraction": "Extracción de datos",
            "identity_verification": "Verificación de identidad",
            "name": "Nombre del documento",
            "permissions": "Permisos"
          },
          "title": "Documentos"
        },
        "new": {
          "error": "Ocurrió un error. Por favor inténtelo de nuevo.",
          "success": "El documento se creó correctamente.",
          "title": "Nuevo documento"
        }
      }
    },
    "email_preference": {
      "buttons": {
        "unsubscribe": "o darme de baja de todas las comunicaciones",
        "update": "Actualizar mis preferencias de correo electrónico"
      },
      "checkboxes": {
        "application_updates": {
          "description": "Reciba actualizaciones importantes sobre sus solicitudes de empleo. Cancele su suscripción para dejar de recibir actualizaciones y eliminar todos sus datos de nuestro sistema.",
          "title": "Actualizaciones de la aplicación"
        },
        "new_opportunities": {
          "description": "Recibe noticias sobre nuestra empresa e invitaciones para postular a nuevos empleos.",
          "title": "Nuevas oportunidades y ferias de empleo"
        }
      },
      "footer": {
        "note": "Al cancelar la suscripción se eliminará toda su información y sus aplicaciones de nuestro sistema.\n"
      },
      "header": {
        "title": "Preferencias de correo electrónico para"
      },
      "not_found": {
        "notice": {
          "header": "¡Ups! No pudimos encontrar tu información\n",
          "message1": "Parece que no pudimos encontrar tu información en nuestro sistema. Esto podría suceder si ya se ha dado de baja tu correo electrónico o si se ha eliminado tu solicitud.",
          "message2": "¡Pero no te preocupes! Seguimos en contacto. Si te interesan nuevas oportunidades, visita nuestra <a class=\"job-listing-page-url\" target=\"_blank\" href=\"%{jobListingPage}\">página de ofertas de empleo</a> para explorar y aplicar a posiciones disponibles."
        }
      },
      "notices": {
        "success": "Preferencias actualizadas con éxito",
        "unsubscribe": {
          "error": "¡Ups! Algo salió mal. Por favor, inténtalo de nuevo.",
          "success": "Te has dado de baja exitosamente de todas las comunicaciones."
        }
      },
      "unsubscribe_confirmation": {
        "notice": {
          "header": "Te has dado de baja exitosamente de todas las comunicaciones.",
          "message": "Lamentamos que te vayas. Si cambias de opinión en el futuro y estás interesado en nuevas oportunidades, no dudes en visitar nuestra <a class=\"job-listing-page-url\" target=\"_blank\" href=\"%{jobListingPage}\">página de ofertas de empleo</a> para explorar y postularte a los puestos vacantes."
        }
      }
    },
    "facebook_page": {
      "record": {
        "button": {
          "disconnect": "Desconectar",
          "login": "INICIAR SESIÓN CON FACEBOOK",
          "renew": "Renovar",
          "renew_all": "Renovar todas"
        },
        "label": {
          "actions": "Acciones",
          "audit": {
            "disconnected": "Desconectado por %{user}",
            "last_renew": "Última renovación por %{user}"
          },
          "auto_renew": {
            "one": "Renovación automática en 1 día",
            "other": "Renovación automática en %{count} días"
          },
          "confirmation": {
            "disconnect": {
              "text": "¿Está seguro de que desea desconectar esta página? Para volver a conectarla, debe iniciar sesión con Facebook nuevamente.",
              "title": "Desconectar página de Facebook"
            }
          },
          "create": {
            "error": "Error al crear %{pages}. Inténtelo de nuevo.",
            "success": "%{pages} fue conectada exitosamente. "
          },
          "description": "Gestione sus Páginas de Facebook ya conectadas o conecte nuevas a Talkpush.  Para conectar nuevas páginas o volver a conectar una después de un token invalidado, haga clic en Iniciar sesión con Facebook y seleccione las páginas para las que desea generar tokens.",
          "disconnect": {
            "error": "Error al actualizar %{page}. Inténtelo de nuevo.",
            "success": "%{page} se desconectó exitosamente."
          },
          "facebook_id": "ID",
          "lead_ads_warning": {
            "contact": "o comuníquese con Soporte de Producto para obtener ayuda.",
            "learn_more": "Aprenda más aquí",
            "learn_more_url": "https://help.talkpush.com/es/articles/8892130-renueva-o-desconecta-el-acceso-a-tu-pagina-de-facebook-en-talkpush",
            "testing_tool": "Pruebe su integración de anuncios para clientes potenciales (Lead Ads).",
            "text": "Deberá tener el nivel de acceso adecuado para poder generar correctamente los Tokens para una página de Facebook. Consulte la lista de permisos necesarios para asegurarse de que los bots y los anuncios de clientes potenciales (Lead Ads) funcionen correctamente.",
            "title": "Alerta"
          },
          "login": {
            "error": "Error de inicio de sesión"
          },
          "name": "Nombre",
          "no_data": "Presiona para llenar",
          "renew": {
            "error": "Error al actualizar %{page}. Inténtelo de nuevo.",
            "success": "El token de acceso para %{page} se renovó exitosamente"
          },
          "required_permissions": "Permisos requeridos",
          "resubscribe": {
            "error": "Error al actualizar %{pages}. Inténtelo de nuevo.",
            "success": "El token de acceso para %{pages} se renovó exitosamente"
          },
          "status": "Estado",
          "title": "Acceso a la página de Facebook",
          "updatedAt": "Fecha de actualización"
        },
        "modal": {
          "body": {
            "first_caption": "Para volver a conectarlas, tendrá que iniciar sesión en Facebook nuevamente y seleccionarlos a ellos y a cualquier otra página que desee que permanezca conectada.",
            "second_caption_end": "o comuníquese con nuestro equipo de soporte para guiarlo a través de este proceso.",
            "second_caption_link": "Más información sobre el Tablero de Tokens de Acceso de Facebook",
            "second_caption_link_url": "https://help.talkpush.com/es/articles/8706222-tablero-de-tokens-de-acceso-de-facebook",
            "second_caption_start": "¿No está seguro de cómo proceder? →"
          },
          "button": {
            "continue": "Continuar iniciando sesión con Facebook"
          },
          "header": "Cualquier página de Facebook previamente conectada aparecerá seleccionada.",
          "warning": "Al deseleccionarlas, Meta invalidará sus tokens y la página se desconectará."
        },
        "status": {
          "active": "Activo",
          "expired": "Expirado",
          "expiring_soon": "Expirará pronto",
          "invalid": "Inválido",
          "tooltip": {
            "active": "Para utilizar las funciones con esta página, haga clic en el botón Iniciar sesión en Facebook y siga los pasos para volver a autenticarla.",
            "expired": "Este token ha caducado. Haga clic en el botón Iniciar sesión en Facebook y siga los pasos para volver a autenticarlo.",
            "invalid": "Facebook ha invalidado este token debido a un problema de autenticación. Haga clic en el botón Iniciar sesión en Facebook y siga los pasos para volver a autenticarlo."
          }
        }
      }
    },
    "folder": {
      "label": {
        "associated_campaigns": "Campañas asociadas",
        "create_custom_folder": "Crear una carpeta personalizada",
        "create_folder": "Crear carpeta",
        "delete_folder": "Eliminar carpeta",
        "description": "Descripción",
        "edit_folder": "Editar carpeta %{title}",
        "folder_name": "Nombre de la carpeta",
        "select_folders": "Seleccionar carpetas",
        "settings": "Configuración de carpeta",
        "workflow": "Flujo de trabajo"
      },
      "text": {
        "associate_to_campaigns": "Asociar a todas las campañas nuevas y existentes",
        "associated_campaigns": {
          "one": "%{count} campaña asociada",
          "other": "%{count} campañas asociadas"
        },
        "candidates_can_move_to": "Los candidatos pueden ser trasladados a",
        "cannot_dissaociate_with_candidates": "Las campañas que están actualmente asociadas y tienen candidatos en la carpeta no se pueden disociar.",
        "settings_description": "Administre sus carpetas, cree nuevas y vincúlelas a campañas, y determine qué movimientos de carpetas pueden realizar sus usuarios.",
        "text_counter": "%{count}/100 caracteres",
        "warn_has_candidates": {
          "one": "Advertencia: Todos los candidatos en %{folder} deben ser movidos manualmente a otra carpeta. Todavía hay <1>count</1> candidato en esta carpeta en la siguiente campaña:",
          "other": "Advertencia: Todos los candidatos en %{folder} deben ser movidos manualmente a otra carpeta. Todavía hay <1>count</1> candidatos en esta carpeta en las siguientes campañas:"
        },
        "workflow_description": "Determine a qué carpetas se pueden mover los candidatos mediante las acciones manuales de Administradores y Administradores Limitados. <1>link</1>"
      }
    },
    "guest": {
      "label": {
        "add": "Agregar invitado",
        "create": {
          "desc": "Configure los invitados para compartir fácilmente los perfiles de los candidatos con ellos por correo electrónico o WhatsApp.",
          "error": "Ocurrió un error. Por favor inténtelo de nuevo.",
          "required_value": "Agregue al menos un método de comunicación para comunicarse con este Invitado y poder guardar.",
          "success": "Invitado creado exitosamente",
          "title": "Crear invitado"
        },
        "name": "Nombre",
        "new": {
          "title": "Nuevo invitado"
        },
        "no_results": "No hay resultados",
        "phone_number": "Número de teléfono",
        "role": "Rol",
        "search": "Buscar Invitados",
        "update": {
          "success": "Invitado actualizado correctamente",
          "title": "Actualizar invitado"
        }
      }
    },
    "job_boards": {
      "label": {
        "add_contract": "Agregar contrato",
        "advertise": "Anunciar",
        "current_campaign_settings": "Configuración actual de Campaña",
        "go_to_settings": "Ir a Configuración de Campaña"
      },
      "text": {
        "boost_reach": "Impulsa tu alcance al instante",
        "campaign": {
          "access_restricted": {
            "description": "Esta función sólo está disponible para usuarios con permisos especiales. Si desea acceder a ella, póngase en contacto con su gestor de cuenta.",
            "title": "Acceso restringido"
          },
          "description": "Publica tu vacante al instante en miles de bolsas de trabajo, simplificando la contratación de alto volumen y entregando personas candidatas más rápido.",
          "final_purchase_warning": {
            "description": "Todas las transacciones realizadas en esta plataforma no son reembolsables y no pueden anularse. Por favor, revise su pedido detenidamente antes de completar la compra.",
            "title": "Aviso importante: Las compras son definitivas"
          },
          "title": "Publica esta Campaña en cualquier bolsa de trabajo"
        },
        "contract": {
          "description": "¿Tienes acuerdos vigentes con bolsas de trabajo? Conéctalos aquí para publicar tus vacantes fácilmente usando tus contratos actuales, ahorrando tiempo y costos adicionales innecesarios.",
          "title": "Conecta tus propias bolsas de trabajo"
        },
        "errors": {
          "not_whitelisted": "Su cuenta no está autorizada para crear anuncios de empleo. Póngase en contacto con el servicio de asistencia para obtener ayuda.",
          "order_limit_reached": "Ha alcanzado el máximo de órdenes permitidas para su cuenta. Para aumentar su límite, póngase en contacto con el servicio de asistencia."
        },
        "inbound": {
          "description": "Inserta la dirección de correo electrónico dedicada de esta Campaña en la sección que tu bolsa de trabajo proporciona para recibir postulaciones.",
          "title": "Importa personas candidatas desde publicaciones en bolsas de trabajo"
        },
        "ineligible": {
          "description": "La publicidad de empleos solo está disponible para Campañas configuradas como \"Solicitud de Empleo\" y preparadas para recibir nuevas postulaciones.",
          "title": "La publicidad de empleos no está disponible para esta Campaña"
        },
        "job_boards": "Bolsas de trabajo",
        "opn": {
          "description": "Compartiremos tu vacante con nuestras bolsas de trabajo asociadas sin costo. Las publicaciones elegibles pueden mostrarse como listados gratuitos—nunca como anuncios patrocinados o pagos—aunque no podemos garantizar su inclusión en todos los sitios. Esta distribución gratuita es independiente de las opciones de publicidad pagada.",
          "requirements_1": "Requiere una Campaña de Solicitud de Empleo que esté recibiendo postulaciones activamente.",
          "title": "Anuncio gratuito"
        }
      },
      "vonq": {
        "alert": {
          "dismiss-button": {
            "close": "Cerrar"
          }
        },
        "basket": {
          "add": "Agregar a la Campaña",
          "add-product": "Agregar a mis contratos",
          "calculating-times": "Calculando tiempos, por favor espera...",
          "delivery-time": "Tiempo de entrega",
          "delivery-time-disclaimer": "La entrega puede tardar hasta {workingDays} días hábiles",
          "delivery-time-explanation-learn-why": "Descubre por qué",
          "description": "Incluye productos de marketing de empleo y contratos propios.",
          "immediate-delivery-time": "La Campaña estará en línea de inmediato",
          "processing-time-disclaimer": "Tu primer pedido en estos canales puede tardar hasta {workingDays} días hábiles en procesarse",
          "product": {
            "remove-confirmation": {
              "accept": "Aceptar",
              "decline": "Rechazar",
              "title": "¿Confirmas que deseas eliminar este producto?"
            },
            "time-to-process": "{timeToProcess} para procesar"
          },
          "products": {
            "empty": "No hay productos en el carrito",
            "part-of-bundle-warning": "Este producto pertenece al paquete que tienes en tu carrito",
            "total-amount": "Monto total",
            "wallet-balance": "Saldo de billetera"
          },
          "remove": "Eliminar de la Campaña",
          "review-error-atleast-one-product-required": "Se requiere al menos un producto o contrato para poder ordenar la Campaña",
          "review-error-title": "Por favor revisa el(los) siguiente(s) error(es):",
          "title": "Carrito",
          "title-explanation": "{quantity} canales",
          "total-delivery-and-processing-times": "La Campaña estará en línea en {workingDays} días hábiles totales"
        },
        "campaign": {
          "add": {
            "common-fields": "Campos comunes",
            "contact-information": {
              "email": "Correo electrónico",
              "email-explanation": "Algunos canales requieren un correo electrónico para publicar una vacante. Deja un correo de contacto o un correo general de la empresa.",
              "name": "Nombre",
              "name-explanation": "Deja un nombre de contacto (o información general de la empresa) para que tu vacante se publique correctamente en las bolsas de trabajo que lo requieran."
            },
            "copy": {
              "accept": "Copiar tal cual",
              "decline": "Déjame elegir productos/contratos",
              "description": "Los siguientes productos/contratos estaban en esta Campaña. ¿Quieres duplicar la Campaña con estos o seleccionar nuevos productos/contratos?",
              "title": "¿Quieres copiar la Campaña con los productos/contratos existentes?"
            },
            "form-contracts": {
              "heading": {
                "title": "Contratos agregados"
              }
            },
            "heading": "Crear Campaña",
            "job-criteria": {
              "employment-type": "Tipo de empleoo",
              "heading": "Criterios del puesto",
              "heading-explanation": "Usaremos estos datos para dirigirnos mejor a tu público objetivo",
              "level-of-education": "Nivel de educación",
              "minimum-years-of-experience": "Años mínimos de experiencia"
            },
            "job-posting-details": {
              "application-link": "Enlace a la página de postulación",
              "application-link-explanation": "Agrega el enlace donde la persona candidata completa la postulación (también puede ser la página de detalles de la vacante)",
              "application-link-explanation-placeholder": "Ingresa una URL",
              "campaign-name": "Nombre de la Campaña",
              "campaign-name-explanation": "El Nombre de la Campaña se utiliza para distinguir fácilmente las vacantes en la lista de Campañas. Por ejemplo, el nombre de Campaña podría ser «Gerente de Desarrollo de Software», mientras que el Título del Puesto podría ser «¿Quieres liderar un equipo de desarrolladores de software? ¡Únete!». Esto solo lo ves tú y no las personas candidatas.",
              "job-description": "Descripción del puesto",
              "job-description-explanation-1": "La descripción del puesto se extrae directamente de tu ATS, por lo que puedes empezar a editarla de inmediato. Nota importante: es posible que no todo el formato se importe correctamente. Asegúrate de revisar bien tu texto antes de ordenar.",
              "job-function-explanation": "Por favor completa la función del puesto",
              "job-title-placeholder": "El título de la publicación en los distintos canales donde se publicará",
              "work-location": {
                "company-logo-url": "URL del logo de la empresa",
                "company-logo-url-description": "Ingresa una URL pública disponible",
                "explanation": "Agrega la ubicación donde trabajará esta persona",
                "work-location": "Detalles de la ubicación de trabajo para tu vacante"
              }
            },
            "order-fail": "Algo salió mal al ordenar la Campaña",
            "order-success": "Tu pedido ha sido realizado"
          },
          "ask-status": "Consultar estado",
          "audience": "Audiencia",
          "cancel-campaign": "Cancelar Campaña",
          "cancel-campaign-confirmation": "¿Estás seguro de que quieres cancelar la Campaña? No es posible transferir el pago a otra Campaña ni obtener un reembolso.",
          "cancel-campaign-product-confirmation": {
            "accept": "Cancelar producto",
            "description": "¿Estás seguro de que quieres cancelar el producto? No es posible transferir el pago a otro producto ni obtener un reembolso."
          },
          "card": {
            "channel": {
              "actions": "Acciones",
              "clicks": "Clics",
              "end-date": "Fecha de finalización",
              "link": "Enlace de la bolsa",
              "start-date": "Fecha de inicio"
            },
            "create-new-from-this": "Crear nuevo a partir de este",
            "edit": "Editar",
            "hide-campaign-details": "Ocultar detalles de la Campaña",
            "job-id": "ID de vacante: {jobId}",
            "modify-date": "Última modificación: {dateTime}",
            "modify-date-explanation": "Hora de los cambios procesados",
            "no-actions": "Sin acciones",
            "not-delivered": "Aún sin entregar",
            "order-date": "Fecha de pedido: {date}",
            "product-take-offline-success": "El producto se ha desactivadoo",
            "show-campaign-details": "Aún sin entregar",
            "take-offline": "Desactivar",
            "take-offline-success": "La Campaña se ha desactivado",
            "target-audience": "Público objetivo"
          },
          "contact-info": {
            "email-placeholder": "Ingresa la dirección de correo electrónico de la persona de contacto",
            "heading": "Información de contacto",
            "heading-explanation": "La información de contacto puede diferir de la información de la persona reclutadora. Las personas candidatas usarán la información de contacto para contactarse sobre la aplicación. ",
            "name-placeholder": "Ingresa el nombre completo de la persona de contacto",
            "phone-number": "Número de teléfono",
            "phone-number-placeholder": "Ingresa el número de teléfono de la persona de contacto",
            "same-as-recruiter-info": "La información de contacto es la misma que la del reclutador (si la información del reclutador no tiene número de teléfono, puedes ingresar opcionalmente tu número)"
          },
          "contract-posting-requirements": {
            "dependent-fields-need-to-be-filled-to-get-options": "Los campos «{fieldLabels}» deben completarse para obtener opciones en este campo",
            "dependent-fields-need-to-be-filled-to-reactively-render": "Los campos \"{fieldLabels}\" deben completarse para que este campo se actualice",
            "heading": "Requisitos de publicación",
            "no-required-field-entered": "No se ingresó ningún valor para {labelName} en otros formularios",
            "some-section-fields-are-optional-and-hidden": "¡Algunos de los requisitos de publicación de esta sección son opcionales y están ocultos!",
            "type-to-search": "Busca valores escribiendo en el campo"
          },
          "contracts-explanation": "Completa los detalles que requiere el canal.",
          "copy-campaign-confirmation": {
            "accept": "Copiar Campaña",
            "title": "¿Estás seguro de que deseas duplicar esta campaña?"
          },
          "copy-campaign-warning": "Había productos/contratos pedidos como parte de esta Campaña que ya no existen y no se han añadido a tu carrito",
          "copy-success": "Tu Campaña ha sido creada",
          "create": {
            "continue": "Guardar y continuar",
            "job-portals": {
              "contact-information": "Información de contacto para personas candidatas",
              "criteria": "Criterios del puesto",
              "posting-details": "Detalles de la publicación de la vacante"
            },
            "my-contracts": "Mis contratos"
          },
          "edit": {
            "not-editable": "La Campaña no es editable",
            "ordered-product-has-no-posting-requirements": "No se encontró el contrato o producto con el ID de producto pedido especificado o no tiene requisitos de publicación",
            "save": "Guardar Campaña",
            "save-take-effect-disclaimer": "Los cambios pueden tardar en aplicarse"
          },
          "form": {
            "heading": {
              "title": "Crea tu anuncio de empleo",
              "title-explanation": "Completa la información necesaria para tu publicación de empleo. Algunos campos son obligatorios para que las bolsas de trabajo la publiquen"
            }
          },
          "header": {
            "duplicate-to-new": "Duplicar a nueva Campaña"
          },
          "ordered-products": "Productos solicitados",
          "organization": {
            "company": {
              "logo": "Logo de la empresa"
            },
            "sidebar-company-logo": "URL del logo de la organización",
            "sidebar-name": "Nombre de la organización que publica",
            "sidebar-title": "Organización"
          },
          "posting-details": {
            "allowed-html-tags": "Etiquetas HTML permitidas: {tags}",
            "description": "Descripción",
            "heading-explanation": "Los detalles de publicación representan la información de la vacante que se publicará en los productos seleccionados en esta solicitud.",
            "line-1": "La organización a la que se dirigirá la publicación de la vacante.",
            "line-2": "La empresa que realmente está contratando a la persona candidata.",
            "organization": {
              "company-logo": "Logotipo de la empresa",
              "company-logo-description": "Sube un logo de la empresa",
              "name": "Nombre de empresa",
              "name-placeholder": "Ingresa el nombre de la empresa"
            },
            "salary": {
              "currency": "Moneda",
              "from": "De",
              "indication": "{fromPrice}{fromCurrency} a {toPrice}{toCurrency} {period}",
              "period": "Período",
              "to": "Hasta"
            },
            "salary-indication": {
              "from-placeholder": "Ingresa un valor para la hora"
            },
            "sidebar-posting-description": "Descripción de la publicación",
            "sidebar-posting-employment-type": "Tipo de empleo de la publicación",
            "sidebar-posting-title": "Título de la publicación",
            "sidebar-salary-indication-period": "Período de indicación salarial de la publicación",
            "sidebar-salary-indication-range-currency": "Moneda del rango de salario indicado en la publicación",
            "sidebar-salary-indication-range-to": "Máximo del rango de salario indicado en la publicación",
            "sidebar-title": "Detalles de la publicación",
            "sidebar-weekly-working-hours-to": "Máximo de horas de trabajo semanales de la publicación",
            "title-explanation": "Este es el título del puesto que se mostrará a tus personas candidatas",
            "weekly-working-hours": {
              "from": "De",
              "to": "Hasta"
            },
            "weekly-working-minutes": {
              "from-placeholder": "Ingresa un valor para los minutos"
            }
          },
          "posting-requirements": {
            "posting-duration-days-explanation-1": "Si el valor ingresado en el campo difiere del valor ingresado durante la creación del contrato, se usará este valor.",
            "posting-duration-days-explanation-2": "Si la bolsa de trabajo tiene su propio campo de duración, asegúrate de que coincida."
          },
          "product": {
            "id": "ID de producto",
            "status": "Estado"
          },
          "products": {
            "status": "Estados de productos solicitados"
          },
          "recruiter-info": {
            "email-explanation": "Algunos canales requieren un correo electrónico para publicar una vacante. Deja un correo de contacto o un correo general de la empresa",
            "email-placeholder": "Correo electrónico de la persona reclutadora",
            "heading": "Información de la persona reclutadora\n",
            "heading-explanation": "La persona reclutadora es quien utiliza el ATS para crear la Campaña y generalmente forma parte de la Empresa cuya ID solicitamos primero",
            "name": "Nombre completo",
            "name-explanation": "Deja un nombre de contacto (o información general de la empresa) para que tu vacante se publique correctamente en las bolsas de trabajo que lo requieran",
            "name-placeholder": "Nombre completo de la persona reclutadora",
            "sidebar": {
              "name": "Nombre de la persona reclutadora",
              "title": "Información de la persona reclutadora"
            }
          },
          "salary": {
            "indication": "{fromPrice}{fromCurrency} a {toPrice}{toCurrency} {period}"
          },
          "save-success": "La campaña se ha guardado",
          "select-channels": {
            "no-items-in-basket": "Necesitas al menos un producto o un contrato añadido a la campaña para continuar"
          },
          "smartfill": {
            "ai": "IA",
            "button": "Completar con IA",
            "description": "La IA intentará completar el formulario con los datos proporcionados previamente. Solo rellena los campos en blanco.",
            "failed": "Relleno Inteligente falló, intenta de nuevo más tarde",
            "field-overlay": "Cargando sugerencias, por favor espera...",
            "smartfill": "Relleno Inteligente",
            "status": {
              "errored": "Con error"
            }
          },
          "status": "Estado de la campaña",
          "status-detail": {
            "click-to-copy": "Haz clic para copiar el texto de arriba",
            "more-info": "Más información",
            "more-information": "Más información",
            "more-information-detail": "Si los portales de empleo solicitan detalles más específicos, puedes compartir el error del portal como se muestra a continuación:",
            "status": {
              "awaiting-successful-payment": "En espera de pago exitoso",
              "in-progress": "En progreso",
              "not-processed": "No procesado",
              "offline": "Desconectado",
              "online": "En línea",
              "view-invoices": "Ver facturas"
            }
          },
          "target-group": {
            "education-level-placeholder": "Selecciona un nivel educativoo",
            "employment-type": "Tipo de empleo",
            "employment-type-placeholder": "Selecciona un Tipo de empleo\n",
            "heading": "Público objetivo",
            "heading-explanation": "Completa los detalles de tu público objetivoo",
            "industry-explanation": "Por favor, completa la industria del puesto",
            "industry-placeholder": "Selecciona una industria\n",
            "job-function-explanation": "Por favor, completa la función del puesto",
            "seniority-placeholder": "Selecciona un nivel de antigüedad",
            "sidebar-title": "Grupo objetivo"
          },
          "urls": {
            "application-url": "URL de postulación",
            "application-url-explanation": "Ingresa la URL que se usará como página de destino para tu postulación",
            "application-url-placeholder": "Ingresa el enlace de la página donde la persona candidata postulará al puesto",
            "heading": "URLs",
            "heading-explanation": "Completa los detalles de tu puesto y de las páginas de postulación",
            "job-page-url": "URL de la página de empleo",
            "job-page-url-placeholder": "Ingresa el enlace de la página con la descripción de la vacante",
            "sidebar-application-url": "URL de la postulación",
            "sidebar-job-page-url": "URL de la descripción de la vacante",
            "sidebar-title": "URLs"
          },
          "work-location": {
            "allows-remote-work": "¿Permite trabajo remoto?"
          },
          "working-location": {
            "address-line-1": "Dirección línea 1",
            "address-line-1-placeholder": "Ingresa la primera línea de dirección",
            "address-line-2": "Dirección línea 2",
            "address-line-2-placeholder": "Ingresa la segunda línea de dirección",
            "allows-remote-work": "¿Permite trabajo remoto?",
            "city": "Ciudad",
            "city-placeholder": "Ingresa la ciudad de la dirección",
            "country": "País",
            "country-placeholder": "Ingresa el país de la dirección",
            "heading": "Lugar de trabajo",
            "heading-explanation": "Completa los detalles de la ubicación del trabajo",
            "postcode": "Código postal",
            "postcode-placeholder": "Ingresa el código postal de la dirección",
            "sidebar-address-line-1": "Dirección del lugar de trabajo (línea 1)",
            "sidebar-city": "Ciudad del lugar de trabajo",
            "sidebar-country": "País del lugar de trabajo",
            "sidebar-postcode": "Código postal del lugar de trabajo",
            "sidebar-title": "Lugar de trabajo"
          }
        },
        "checkout": {
          "order-campaign": "Ordenar campaña"
        },
        "common": {
          "application-page": "Página de postulación",
          "autocorrection-must-be-applied": "Se debe aplicar la siguiente corrección automática, haz clic para aplicar",
          "back-to": "Volver a {previousTabTitle}",
          "bold": "Negrita",
          "bullet-list": "Lista de viñetas",
          "cannot-accept-file": "No se puede aceptar ese archivo",
          "channel": "Canal",
          "channel-name": "Nombre del canal",
          "characters": "Caracteres",
          "clear-formatting": "Borrar formato",
          "contracts": "Contratos",
          "currency": "Moneda",
          "diff-added-removed": "Rojo indica valores eliminados; verde indica valores añadidos",
          "education-level": "Nivel educativo",
          "employment-type": "Tipo de empleo\n",
          "enter-a-value": "Ingresa un valor",
          "field-is-required": "Este campo es requerido",
          "field-should-be-email": "Este campo debe ser un correo electrónico",
          "field-should-be-float": "Este campo solo puede contener números, puntos y comas",
          "field-should-be-float-with-comma-only": "Este campo no debe contener puntos.",
          "field-should-be-more-than-zero": "Este campo debe ser mayor que 0",
          "field-should-be-url": "Este campo debe ser una URL",
          "field-should-be-utm": "Este campo debe contener un código UTM (seguimiento) válido",
          "field-should-contain-an-image-with-url": "Este campo debe contener una imagen",
          "field-should-meet-regex": "Este campo no cumple con los requisitos. Por favor, revisa los requisitos leyendo la información junto a la etiqueta.",
          "file-too-big": "Archivo demasiado grande, selecciona algo menor que {size}",
          "file-upload-load-error": "Ocurrió un error al cargar la herramienta de carga de archivos",
          "fullscreen": "Pantalla completa",
          "hide-all-fields": "Ocultar todos los campos",
          "hide-optional-fields": "Ocultar campos opcionales",
          "hit-enter-for-adding-tag": "Presiona Enter para agregar tu(s) etiqueta(s)",
          "id": "ID",
          "important-notice": "Aviso importante",
          "industry": "Industria",
          "input-number-please-enter-non-default-value": "Déjalo en blanco para usar el valor predeterminado de {{defaultValue}}",
          "insert-edit-link": "Insertar/editar enlace",
          "italic": "Itálica",
          "job-page": "Página de empleo",
          "load-more": "Cargar más...",
          "loading": "Cargando...\n",
          "loading-option": "Cargando opción, por favor espera...",
          "loading-options": "Cargando opciones, por favor espera...",
          "maximum": "Máximo",
          "minimum": "Mínimo",
          "network-may-be-blocking": "Tu red podría estar bloqueando",
          "not-specified": "No especificado",
          "numbered-list": "Lista numerada",
          "optional": "Opcional",
          "or": "O",
          "organization": "Organización",
          "please-fill-in-field": "Por favor completa los campos obligatorios",
          "proceed-to": "Continuar a {nextTabTitle}",
          "products": "Productos",
          "range": {
            "days": {
              "long": "días",
              "short": "días"
            },
            "hourly": "por hora",
            "hours": {
              "long": "horas",
              "short": "hrs"
            },
            "minutes": {
              "long": "minutos",
              "short": "min"
            },
            "monthly": "mensual",
            "months": {
              "long": "meses",
              "short": "meses"
            },
            "seconds": {
              "long": "segundos",
              "short": "seg"
            },
            "weeks": {
              "long": "semanas",
              "short": "sem"
            },
            "yearly": "anual"
          },
          "remove-link": "Eliminar enlace",
          "required": "Es requerido",
          "requires-action": "Requiere acción",
          "section-empty": "{prefix}{title}{suffix}",
          "section-empty-prefix": "No pudimos encontrar ninguno",
          "select-a-date-placeholder": "Selecciona una fecha",
          "select-an-option": "Selecciona una opción",
          "seniority": "Antigüedad",
          "show-all-fields": "Mostrar todos los campos",
          "show-optional-fields": "Mostrar campos opcionales",
          "solution": "Solución",
          "there-are-no-options": "No hay opciones",
          "there-are-no-options-for-search-value": "No hay opciones para {inputValue}",
          "toggle-all-fields": "Mostrar/ocultar todos los campos",
          "toggle-all-optional-fields": "Mostrar/ocultar todos los campos opcionales",
          "type-to-get-options": "Escribe para obtener opciones",
          "weekly-working-hours": "Horas laborales semanales",
          "work-location": "Ubicación de trabajo",
          "working-time-indicator": "trabajando"
        },
        "contract": {
          "add": {
            "add-new-group": "Agregar nuevo grupo",
            "button": "Agregar nuevo contrato",
            "contract-group": {
              "name-placeholder": "Ingresa un nombre de grupo"
            },
            "contract-group-explanation": "Puedes seleccionar o crear un nuevo grupo de contratos",
            "contract-name-placeholder": "Escribe un nombre de contrato",
            "credentials": {
              "authenticated": "Tu autenticación se realizó con {channelName}",
              "fields-disabled-until-authenticated": "Los campos se habilitarán una vez que completes la autenticación",
              "heading": "Credenciales",
              "initialize-authentication": "Iniciar autenticación"
            },
            "edit": {
              "save-contract": "Guardar contrato"
            },
            "error-title": "Por favor revisa los siguientes errores:",
            "heading": "Crear contrato",
            "heading-explanation": "Completa la información necesaria para tu(s) oferta(s) de empleo. Algunos campos son obligatorios para que los portales de empleo publiquen en ellas",
            "instructions": {
              "following-instructions": "Entiendo que mi contrato solo se puede activar si sigo las instrucciones",
              "heading": "Instrucciones"
            },
            "optional-details": {
              "contract-alias-placeholder": "Ingresa un alias de contrato",
              "contract-expiry-placeholder": "Vencimiento del contrato",
              "credits-placeholder": "Ingresa el número de créditos",
              "currency": "Moneda",
              "posting-duration-days-explanation-1": "Ingresa por cuántos días deseas que la oferta de empleo esté publicada",
              "purchase-price-placeholder": "Precio de compra"
            },
            "posting-requirements-defaults": {
              "heading": "Valores predeterminados de requisitos del canal",
              "heading-explanation": "Puedes completar cualquiera de estos valores para usarlos en tus futuros pedidos de campaña"
            },
            "select-channel": "¿Qué contrato te gustaría agregar?",
            "select-channel-explanation": "Escribe para buscar y seleccionar el proveedor de contrato que deseas agregar",
            "select-group": "Selecciona un grupo",
            "success": "El contrato \"{name}\" ha sido creado"
          },
          "delete": "Eliminar contrato",
          "delete-outdated-contract": "Por favor elimina este contrato desactualizado y crea uno nuevo",
          "details": {
            "outdated-contract": "Contrato desactualizado"
          },
          "edit": {
            "success": "El contrato \"{name}\" ha sido guardado"
          },
          "filters": {
            "apply-filters": "Aplicar filtros",
            "channel-name": "Nombre del canal",
            "channel-name-placeholder": "Escribe un nombre de canal",
            "group-id": "Grupo",
            "group-id-placeholder": "Selecciona un grupo"
          },
          "group": {
            "add": {
              "success": "Se ha creado el grupo de contratos \"{groupName}\""
            },
            "delete": "Eliminar grupo",
            "name": "Grupo",
            "remove": {
              "success": "Se ha eliminado el grupo de contratos \"{groupName}\""
            },
            "update": {
              "success": "El grupo de contratos \"{groupName}\" se actualizó"
            }
          },
          "group-conflict": {
            "accept": "Sí, elimínalos",
            "decline": "No, manténlos",
            "description": "Solo es posible agregar contratos del mismo grupo a tu cesta. Si agregas un contrato de otro grupo, se eliminarán los contratos añadidos anteriormente. ¿Estás seguro de que quieres eliminar los siguientes contratos de tu cesta?",
            "title": "¡No se pudo agregar el contrato \"{contractName}\"!"
          },
          "list": {
            "contracts": {
              "list": {
                "heading": "Mis contratos",
                "heading-description": "Aprovecha tus propios contratos de bolsa de trabajo para publicar campañas"
              }
            },
            "table-header": {
              "action": "Acción",
              "channel-name": "Nombre del canal",
              "expiry-date": "Fecha de vencimiento del contrato",
              "group-name": "Nombre del grupo",
              "purchase-price": "Precio de compra",
              "purchased": "Adquirido"
            }
          },
          "remove": {
            "success": "El contrato \"{name}\" ha sido eliminado"
          },
          "remove-contract-confirmation": {
            "accept": "Eliminar contrato",
            "title": "¿Estás seguro de que quieres eliminar el contrato?"
          },
          "remove-contract-group-confirmation": {
            "accept": "Eliminar grupo",
            "description": "¿Estás seguro/a de que quieres eliminar el grupo?",
            "title": "Debes eliminar los contratos de este grupo antes de eliminarlo:"
          },
          "update-contract-group-confirmation": {
            "accept": "Actualizar grupo",
            "title": "¿Estás seguro de que quieres actualizar el grupo?"
          }
        },
        "product": {
          "time-indicator-with-period-and-range": "{period} días hábiles {range}"
        },
        "products": {
          "add": {
            "success": "Producto agregado a la campaña"
          },
          "details": {
            "channel": {
              "type": {
                "aggregator": "Agregador",
                "community": "Comunidad",
                "job-board": "Portal de Empleo",
                "product_bundle": "Paquete de productos",
                "publication": "Publicación",
                "service": "Servicio",
                "social-media": "Redes sociales"
              }
            },
            "cross-postings": "Publicaciones cruzadas",
            "delivery-time": "Tiempo de entrega",
            "duration": "Duración",
            "free-add-on-channel": "Canal adicional gratuito",
            "free-add-on-channels-description": "Agrega cualquiera de estos canales adicionales a tu cesta sin costo si añades al menos un canal premium",
            "free-add-on-channels-heading": "Canales adicionales gratuitos",
            "industries": "Industrias",
            "job-functions": "Funciones laborales",
            "locations": "Ubicaciones",
            "more-premium-channels-description": "Agrega cualquiera de estos canales a tu cesta para mayor exposición de tu campaña",
            "more-premium-channels-heading": "Más canales premium",
            "price": "Precio",
            "processing-time": "Tiempo de procesamiento",
            "processing-time-disclaimer": "Tu primer pedido puede tardar hasta {timeToSetup}",
            "recommended-channel": "Canal recomendado",
            "recommended-channels": "Canales recomendados",
            "recommended-channels-description": "Seleccionadas según información basada en datos para maximizar el alcance y el rendimiento de la campaña."
          },
          "filters": {
            "apply-filters": "Aplicar filtros",
            "filter": {
              "display-all": "Mostrar todo",
              "exclude-recommendations": "Excluir recomendaciones",
              "recommendations-only": "Mostrar solo recomendaciones"
            },
            "filters-are-ignored-with-name": "Al buscar por nombre de producto, se ignorarán los filtros de Título del puesto, Funciones laborales, Industrias y Ubicación",
            "heading": "Filtros de canal",
            "industry-placeholder": "Escribe una industria...",
            "job-function-placeholder": "Selecciona una función laboral",
            "job-title-placeholder": "Escribe un título de puesto...",
            "my-contracts-supported-only": "Incluir solo productos compatibles con Mis Contratos",
            "name": "Nombre del productoo",
            "name-placeholder": "Escribe un nombre de producto...",
            "recommendations": "Recomendaciones",
            "region": "Región del producto",
            "region-placeholder": "Escribe una ubicación...",
            "search-by-product-name": "Buscar por nombre de producto",
            "sort-by": {
              "recent": "Más recientes primero",
              "relevant": "Más relevante primeroo"
            }
          },
          "more-information": "Más información",
          "remove": {
            "warning": "Producto eliminado de la campaña"
          },
          "sort-by": {
            "created-newest-to-oldest": "Más reciente",
            "created-oldest-to-newest": "Más antiguo",
            "ordered-high-to-low": "Más solicitado",
            "ordered-low-to-high": "Menos solicitado",
            "price-high-to-low": "Precio alto",
            "price-low-to-high": "Precio bajo",
            "recommended-first": "Recomendados primero",
            "relevant": "Relevante",
            "title": "Ordenar por"
          },
          "tabs": {
            "contracts": "Mis contratos",
            "my-contracts": {
              "similar-channels": "Explorar canales similares"
            },
            "recommendations": "Recomendaciones de canales",
            "relevant": "Otros canales relevantes"
          },
          "type-filter-by": {
            "bundles-only": "Solo paquetes",
            "free-add-on-only": "Solo complementos gratuitos",
            "mixed": "Todos los tipos"
          }
        },
        "user-journey": {
          "contract": {
            "back-to-list": "Volver a contratos",
            "create-contract": "Crear contrato"
          },
          "job-marketing": {
            "add-contracts": "Agregar contratos",
            "add-contracts-explanation": "Agrega tu propio contrato a aquellos que admiten esta función.",
            "search-products": "Explorar otros canales relevantes",
            "search-products-explanation": "Mostrando resultados para {productNameInput}.",
            "select-contracts": "Administrar contratos",
            "select-contracts-explanation": "Administra tus contratos existentes.",
            "select-products": "Obtener recomendaciones",
            "select-products-explanation": "Esta combinación de canales demuestra ser la mejor para tu público objetivo según 60 millones de registros de datos de desempeño laboral y trabajos similares."
          },
          "job-posting": {
            "basket-summary": "Resumen del carrito",
            "order-confirmation": "Gracias por tu pedido",
            "order-confirmation-create-new-campaign": "Crear una nueva campaña",
            "order-confirmation-explanation-1": "Tu campaña estará en línea en todos los canales dentro de {daysToProcess} días hábiles.",
            "order-confirmation-explanation-2": "Ten en cuenta que algunas plataformas de empleo requieren un tiempo de configuración adicional la primera vez que las uses, lo cual puede tardar hasta {daysToSetup} días hábiles.",
            "order-review": "Revisión del pedido",
            "order-review-explanation": "Revisa los detalles de tu campaña antes de hacer el pedido."
          },
          "landing": {
            "get-recommendations": "Obtener recomendaciones",
            "heading": "Apuntemos al talento adecuado",
            "heading-explanation": "Usaremos esta información para recomendarte los canales de mejor rendimiento, para que puedas llegar a las personas candidatas adecuadas.",
            "industries-explanation": "Ingresa las industrias de esta empresa",
            "job-function-explanation": "Selecciona una función laboral coincidente (se usa para elegir los canales de mejor rendimiento)",
            "job-title-explanation": "Ingresa y selecciona el título del puesto que describe el rol (se usa para elegir los canales de mejor rendimiento)",
            "location-explanation": "Ingresa la ubicación donde deseas buscar personas candidatas"
          },
          "navigation": {
            "create-ads": "Crear anuncios de empleo",
            "get-recommendations": "Obtener recomendaciones",
            "next-step": "Siguiente{delimiter} {stepTitle}",
            "order-campaign": "Solicitar campaña",
            "previous-step": "Anterior{delimiter} {stepTitle}",
            "select-channels": "Seleccionar canales"
          },
          "order-confirmation": "Confirmación de pedido"
        }
      }
    },
    "landing_page": {
      "answer": {
        "booking": {
          "no_answer": "No hay respuesta"
        }
      },
      "apply_resume": {
        "modal": {
          "button": {
            "choose_file": "Seleccionar archivo",
            "upload_again": "Subir de nuevo"
          },
          "description": {
            "empty": "PDF, DOCX (máximo 10 MB)",
            "failed": "Por favor, inténtalo de nuevo",
            "invalid_file": "Por favor, compruebe que ha enviado el documento correcto y que sea legible.",
            "missing_contact_details": "Por favor actualice su currículum y vuelva a intentarlo",
            "not_supported_file": "Por favor, cargue un archivo PDF, DOCX, 10 MB máximo",
            "parsing": "Estamos analizando tu currículum",
            "success": "Currículum subido exitosamente",
            "uploading": "Estamos analizando tu currículum"
          },
          "title": {
            "empty": "Sube tu currículum",
            "failed": "Se produjo un error al analizar su currículum.",
            "invalid_file": "¡Ups! Eso no parece un currículum.",
            "missing_contact_details": "Oops! Faltan datos de contacto esenciales en el currículum.",
            "not_supported_file": "Error de archivo",
            "parsing": "Subiendo currículum...",
            "success": "Currículum subido exitosamente",
            "uploading": "Subiendo currículum..."
          }
        },
        "title": "Aplicar con Currículum"
      },
      "communication_channels": {
        "email": "Correo electrónico",
        "errors": {
          "field_required": "%{field} es requerido."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Además del email, ¿Cuál es la mejor manera para notificarte los pasos a seguir?",
        "whatsapp": "WhatsApp"
      },
      "consent": "Este sitio solo utiliza cookies de sesión que son esenciales para poder navegar por el sitio y usar sus características y funcionalidades. Las cookies de sesión no recopilan datos de identificación personal.",
      "label": {
        "audio": "Audio",
        "booking": {
          "appointment_date": "Fecha y hora",
          "appointment_location": "Ubicación",
          "cancel": "Cancelar",
          "confirm": "Confirmar",
          "duration": "Duración",
          "reschedule": "Reprogramar",
          "timezone": "Zona horaria"
        },
        "click_download": "Haga click aquí para descargar",
        "continue": "Continuar",
        "contract": "Contrato",
        "copy_it": "Cópialo",
        "email": "Correo electrónico",
        "email_it": "Envíalo por Email",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "Subir archivo",
        "first_name": "Nombre",
        "fixed_term": "Término fijo",
        "full_time": "Tiempo Completo",
        "get_started": "Empezar",
        "internship": "Pasantía",
        "job_type": "Tipo de Posición",
        "last_name": "Apellidos",
        "location": "Ubicación",
        "new_recording": "Nueva grabación",
        "next": "Siguiente",
        "no_answer": "Sin Respuesta",
        "part_time": "Medio Tiempo",
        "pause": "Pausar",
        "phone_number": "Número de WhatsApp",
        "picture": "Imagen",
        "play": "Reproducir",
        "play_recording": "Reproducir grabación",
        "post_it": "Publícalo",
        "probationary": "De prueba",
        "proceed": "Iniciar",
        "project": "Proyecto",
        "record_now": "Grabar ahora",
        "regular": "Regular",
        "remote_type": "Remote Type",
        "retake_picture": "Volver a tomar foto",
        "retry": "Reintentar",
        "salary": "Salario",
        "save": "Guardar",
        "seasonal": "Temporal",
        "share": "Compartir",
        "share_it": "Compártelo",
        "snap_photo": "Tomar foto",
        "start_camera": "Iniciar Cámara",
        "start_recording": "Empezar a grabar",
        "stop": "Detener",
        "stop_recording": "Para de grabar",
        "submit": "Envíar",
        "take_picture": "Toma una foto",
        "text": "Texto",
        "tweet_it": "Tuitéalo",
        "undisclosed": "No revelado",
        "upload": "Cargar",
        "upload_again": "Subir de nuevo",
        "upload_time": "La carga del video puede demorar un tiempo, por favor espere.",
        "view_open_positions": "Ver puestos disponibles",
        "view_sample": "Ver muestra",
        "volunteer": "Voluntarios",
        "warning": "Alerta",
        "whatsapp": "WhatsApp",
        "your_progress": "Progreso"
      },
      "notifications": {
        "prefilled_answers": {
          "linkedin": {
            "description": "Hemos utilizado tu perfil de LinkedIn para completar algunos campos. Revisa la información y actualiza las secciones que falten o necesiten ajustes.",
            "title": "Inicio rápido con LinkedIn"
          },
          "resume": {
            "description": "Hemos utilizado su currículum para completar algunos campos. Por favor, revise la información y actualice las secciones que falten o que necesiten ajustes.",
            "title": "Inicio rápido con currículum"
          }
        }
      },
      "persistent_privacy_policy_link": {
        "click": "Lea su <a target=\"_b\" href=\"https://talkpush.com/privacy/\">política de privacidad aquí</a>.",
        "info": "Utilizamos Talkpush para recopilar información y evaluar a los solicitantes."
      },
      "text": {
        "about_company": "Acerca de %{company}",
        "about_our_company": "Sobre nuestra compañía",
        "application_invalid": "Aplicación  no válida",
        "booking": {
          "appointment_confirmation": {
            "description": "Un mensaje de confirmación ha sido enviado a su medio preferido de comunicación.",
            "reschedule": "¿Necesitas hacer algún cambio?",
            "title": "Su cita ha sido programada"
          },
          "appointment_creation_error": "Ocurrió un error al programar su cita. Por favor, intente confirmar su espacio nuevamente.",
          "errors": {
            "booking_unavailable": {
              "description": "Actualmente no hay espacios disponibles. Pero no te alarmes, un reclutador se pondrá en contacto pronto para que puedas programar tu cita.",
              "title": "Todos los espacios fueron reservados"
            },
            "failed_calendar_fetch": {
              "action": "Recargar",
              "description": "Estamos teniendo problemas al cargar los espacios de reservación. Presiona Recargar para intentarlo de nuevo.",
              "title": "Algo salió mal"
            },
            "no_available_slots": {
              "description": "Actualmente no hay espacios disponibles. Pero no te alarmes, un reclutador se pondrá en contacto pronto para que puedas programar tu cita.",
              "title": "Todos los espacios fueron reservados"
            },
            "slot_booked": {
              "description": "El espacio seleccionado ya fue reservado. Selecciona otro espacio disponible."
            }
          },
          "loading": "Organizando espacios de reservación...",
          "no_date_selected": "Elige una fecha para ver los espacios disponibles",
          "no_slot_selected": "No se ha seleccionado un espacio"
        },
        "camera_not_permitted": "El acceso a la cámara está bloqueado.",
        "close_to_new_applications": "Este puesto en específico no está recibiendo nuevas aplicaciones. Presiona el siguiente botón para acceder a todos los puestos disponibles.",
        "close_warning": "En caso de abandonar este cuestionario antes de enviarlo, podrá completarlo en un intento posterior, pero ninguna respuesta/registro previo será visible o editable.",
        "completion_message": "Has completado y enviado con éxito tu aplicación para %{job}. ¡Gracias!",
        "contact_channel": "¿Cuál es la mejor manera de contactarme? ",
        "copied_succesfully": "Copiado con éxito",
        "dropdown_instruction": "Selecciona una opción",
        "expired_signature": {
          "check_email": "Por favor, compruebe su correo electrónico para un nuevo enlace",
          "close": "Puede cerrar esta ventana",
          "description": "Por su seguridad, los enlaces caducan al cabo de cierto tiempo. Ya le hemos enviado un nuevo enlace por correo electrónico. Abra el último mensaje y haga clic en el nuevo enlace para continuar",
          "please_wait": "Espere, por favor",
          "sub_description": "Si no recibe el mensaje en breve, compruebe su carpeta de correo no deseado",
          "title": "El enlace ha caducado"
        },
        "generic_browser_error": "No se puede grabar multimedia. Asegúrate de que haya un dispositivo de captura de multimedia y que estés utilizando el navegador actualizado para tener la mejor experiencia. ",
        "instructions": "Instrucciones: %{text}",
        "invalid_location": "Ingrese una ubicación válida.",
        "job_type_options": {
          "contract": "Contrato",
          "default": "Aplicar para conocer el tipo de trabajo",
          "fixed_term": "Término fijo",
          "full_time": "Tiempo Completo",
          "internship": "Pasantía",
          "part_time": "Medio Tiempo",
          "probationary": "De prueba",
          "project": "Proyecto",
          "regular": "Regular",
          "seasonal": "Temporal",
          "volunteer": "Voluntarios"
        },
        "mic_not_permitted": "El acceso al micrófono está bloqueado.",
        "min_max_char": "La respuesta debe contener entre %{min} y %{max} caracteres. ",
        "no_camera": "No hay cámara disponible.",
        "no_media_device": "Ningún dispositivo multimedia accesible.",
        "no_mic": "No hay micrófono disponible.",
        "no_supported_mimetype": "No hay ningún tipo de medio MIME admitido en este navegador y la calidad de la grabación puede verse afectada. Intenta cambiar a otro navegador o dispositivo.",
        "not_supported_browser": {
          "text": "Dele clic al menú de tres puntos en la esquina superior derecha de la pantalla y abra esta página en su navegador determinado para continuar.",
          "title": "No podrás completar este cuestionario en el navegador the Facebook."
        },
        "our_social_media": "Nuestras Redes Sociales",
        "play_media": {
          "answer": "Reproducido",
          "instruction": "Haga clic en reproducir para comenzar, luego haga clic en el botón 'siguiente' para pasar a la siguiente pregunta.",
          "local_storage_not_present": "Navegador no compatible"
        },
        "pop_up_privacy_policy": "Al hacer clic en Continuar, acepta la <a href=\"%{policy_url}\">Política de Privacidad</a> de %{company} y la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Política de Privacidad</a> del proveedor de servicios. Esto marcará automáticamente la casilla en el formulario.",
        "pop_up_privacy_policy_with_sms": "Al hacer clic en Continuar, acepta recibir mensajes de texto de %{company} y también acepta la <a target=\"_blank\" href=\"%{policy_url}\">Política de privacidad</a> y la <a target=\"_blank\" href=\"https://talkpush.com/privacy/\">Política de privacidad</a> del proveedor de servicios. La frecuencia de los mensajes puede variar. Pueden aplicarse tarifas de mensajes y datos. Responda AYUDA para obtener ayuda. Responda STOP para darse de baja.",
        "privacy_policy": "Acepto y estoy de acuerdo con la  <a target=\"_b\" href=\"%{policy_url}\">Política de Privacidad</a> de %{company} y la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Política de Privacidad</a> del proveedor del servicio.",
        "privacy_policy_talkpush": "Acepto la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Política de Privacidad</a> del proveedor del servicio. ",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "processing_answers": "Por favor espera un momento mientras procesamos tus respuestas.",
        "question_progress": "%{current} de %{size}",
        "rate_your_experience": "Califica tu experiencia",
        "receive_updates": "Quiero recibir actualizaciones a través de SMS, Facebook, Messenger o WhatsApp.\n",
        "rejected_candidate": {
          "description": "Este enlace ya no está activo. Revise los correos electrónicos adicionales o el mensaje enviado con el enlace actualizado para completar este paso.",
          "explore_openings_cta": "Explorar las vacantes actuales",
          "headline": "Gracias por su interés"
        },
        "remote_types": {
          "fully_remote": "Totalmente Remoto",
          "temporarily_remote": "Temporalmente Remoto",
          "wfh_flexible": "Trabajo desde Casa Flexible"
        },
        "salary_types": {
          "annually": "Anual",
          "biweekly": "Quincenal",
          "daily": "Diario",
          "hourly": "Por hora",
          "monthly": "Mensual",
          "one-time": "Una vez",
          "weekly": "Semanal"
        },
        "scroll_to_continue": "Desplácese hasta la parte inferior para activar el botón Continuar.",
        "share_with_network": "Comparte con tu red",
        "size_of_mb": "%{size} de 20mb",
        "sms_privacy_policy_company_only": "Al marcar esta casilla, acepta recibir mensajes de texto de %{company} y también acepta nuestra <a target=\"_blank\" href=\"%{policy_url}\">Política de privacidad</a> y la <a target=\"_blank\" href=\"https://talkpush.com/privacy/\">Política de privacidad</a> del proveedor de servicios. La frecuencia de los mensajes puede variar. Pueden aplicarse tarifas de mensajes y datos. Responda AYUDA para obtener ayuda. Responda STOP para darse de baja.\n",
        "sms_privacy_policy_company_with_terms": "Al marcar esta casilla, acepta recibir mensajes de texto de %{company} y también acepta nuestra <a target=\"_blank\" href=\"%{policy_url}\">Política de privacidad</a>, los <a target=\"_blank\" href=\"%{terms_and_conditions_url}\">Términos y condiciones</a> y la <a target=\"_blank\" href=\"https://talkpush.com/privacy/\">Política de privacidad</a> del proveedor del servicio. La frecuencia de los mensajes puede variar. Pueden aplicarse tarifas de mensajes y datos. Responda AYUDA para obtener ayuda. Responda STOP para darse de baja.",
        "sms_privacy_policy_default": "Al marcar esta casilla, acepta recibir mensajes de texto de %{company} y también acepta la <a target=\"_blank\" href=\"https://talkpush.com/privacy/\">Política de privacidad</a> del proveedor de servicios. La frecuencia de los mensajes variará. Pueden aplicarse tarifas de mensajes y datos. Responda AYUDA para obtener ayuda. Responda STOP para darse de baja.",
        "talkscore_instructions": "Las grabaciones deben tener un mínimo de %{min} segundos y un máximo de 1 minuto. Asegúrese de que el audio sea claro y que no haya sonidos de fondo.",
        "talkscore_listen_and_repeat_instructions": "Las grabaciones deben tener un máximo de 1 minuto. Asegúrese de que el audio sea claro y que no haya sonidos de fondo.",
        "thank_you": "Gracias",
        "trouble_playing_response": "¿Tiene problemas para reproducir esta respuesta?",
        "upload": {
          "error": {
            "failed": {
              "text": "Por favor verifique que es el documento correcto y que es legible. Recomendamos guardar el archivo como png, jpeg o PDF. Si ha confirmado que cargó el documento correcto, haga clic en Reintentar para procesarlo nuevamente.",
              "title": "¡Ups! Encontramos un problema al intentar cargar su documento."
            },
            "max_retries": {
              "text": "Ha alcanzado el número máximo de reintentos para este documento. Haga clic en Siguiente para continuar con la siguiente pregunta o envíela para finalizar esta parte de su proceso.",
              "title": "¡Ups! Este no parece ser el documento que solicitamos"
            },
            "not_supported": "Algunos archivos no se pudieron cargar",
            "partially_recognized": {
              "text": "Por favor verifique que envió el documento correcto y que sea legible. Recomendamos guardar el archivo como png, jpeg o PDF. Si está seguro que cargó el documento correcto, continúe con la siguiente pregunta.",
              "title": "Asegúrese de que este es el documento que solicitamos"
            },
            "recognition_error": {
              "text": "Por favor verifique que es el documento correcto y que es legible. Recomendamos guardar el archivo como png, jpeg o PDF. Si ha confirmado que cargó el documento correcto, haga clic en Reintentar para procesarlo nuevamente.",
              "title": "¡Ups! Encontramos un problema al intentar cargar su documento."
            },
            "unrecognized": {
              "text": "Por favor verifique que envió el documento correcto y que sea legible. Recomendamos guardar el archivo como png, jpeg o PDF. Si está seguro que cargó el documento correcto, continúe con la siguiente pregunta.",
              "title": "¡Ups! Uno de sus documentos no parece ser el documento que solicitamos"
            },
            "upload_error": {
              "text": "Por favor, inténtalo de nuevo",
              "title": "¡Ups! Encontramos un problema al intentar cargar su documento."
            }
          },
          "file_invalid_type": "El formato del archivo debe ser .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "El tamaño del archivo debe ser inferior a 10 MB.",
          "status": {
            "failed": "No reconocido",
            "partially_recognized": "No reconocido",
            "processing": "Procesando",
            "recognition_error": "No reconocido",
            "recognized": "Reconocido",
            "unrecognized": "No reconocido",
            "upload_error": "Error al cargar",
            "uploaded": "Archivo cargado"
          },
          "success": "Su documento ha sido reconocido. Haga clic para continuar con la siguiente pregunta."
        },
        "upload_failed": "Hubo un error al enviar su respuesta. Inténtalo de nuevo.",
        "video_limit": "La duración máxima de la respuesta de video es de 1 minuto."
      }
    },
    "message": {
      "editor": {
        "controls": {
          "alignment": {
            "buttons": {
              "center": "Centrar",
              "left": "Justificar izquierda",
              "right": "Justificar derecha"
            }
          },
          "basic_format": {
            "bold": "Negrita",
            "italic": "Itálica",
            "underline": "Subrayar"
          },
          "call_to_action": {
            "buttons": {
              "add": "Agregar botón",
              "cancel": "Cancelar",
              "edit": "Editar botón",
              "remove": "Quitar botón",
              "save": "Guardar"
            },
            "labels": {
              "link": "Enlace",
              "text": "Texto para mostrar",
              "token": "Seleccione un token de la lista"
            },
            "link_types": {
              "link": "Enlace",
              "token": "Token de Enlace"
            }
          },
          "emoji": {
            "labels": {
              "emoji": "Emoji"
            }
          },
          "font_size": {
            "buttons": {
              "add": "Tamaño de fuente"
            }
          },
          "image": {
            "buttons": {
              "add": "Añadir"
            },
            "labels": {
              "image": "Imagen",
              "paste_image_url": "Pegar URL de imagen"
            }
          },
          "link": {
            "buttons": {
              "add": "Añadir enlace",
              "cancel": "Cancelar",
              "edit": "Editar enlace",
              "remove": "Quitar enlace",
              "save": "Guardar"
            },
            "labels": {
              "link": "Enlace",
              "text": "Texto para mostrar",
              "token": "Seleccione un token de la lista"
            },
            "link_types": {
              "link": "Enlace",
              "token": "Token de Enlace"
            }
          },
          "token": {
            "buttons": {
              "tokens": "Tokens"
            }
          }
        }
      },
      "label": {
        "delete": "Eliminar",
        "duplicate": "Duplicar",
        "edit": "Editar"
      },
      "template": {
        "caption": "El nombre de la plantilla lo ayudará a diferenciar las plantillas, así que hágalo único e identificable.",
        "character_count": "Caracteres restantes %{count} / %{limit}",
        "create_new": "Crear nueva",
        "description": "Configure plantillas de mensajes para todos los canales que se utilizarán por los Flujos Automáticos en todas las etapas del proceso de contratación.",
        "email": {
          "name": "Nombre de la plantilla de correo electrónico",
          "subject_line": "Línea de asunto",
          "tab": "Correo electrónico",
          "title": "Plantillas de correo electrónico"
        },
        "input": {
          "search_bar": {
            "placeholder": "Buscar plantilla de mensaje"
          }
        },
        "messenger": {
          "name": "Nombre de la plantilla de Messenger",
          "tab": "Messenger",
          "title": "Plantillas de Messenger"
        },
        "sms": {
          "name": "Nombre de la plantilla de SMS",
          "tab": "SMS",
          "title": "Plantillas de SMS"
        },
        "text": {
          "approved_by_meta": "Aprobado por Meta",
          "created_by_admin": "Creado por un administrador",
          "created_on": "Creado en %{date} por %{name}",
          "last_edited_on": "Editado en %{date} por %{name}",
          "linked_campaigns_description": "Esta plantilla de mensaje se está utilizando para Flujos Automáticos en las siguientes campañas",
          "update_from_template": "Actualizar mensaje desde plantilla",
          "update_from_template_confirmation": "Este mensaje está actualmente vinculado a una plantilla. Si lo edita, se desvinculará de la Plantilla y cualquier otro cambio deberá realizarse manualmente en esta acción de Flujo automático, ya que ya no se le aplicará ninguna edición masiva de la Plantilla.",
          "update_template": "Actualizar plantilla de mensaje",
          "update_template_confirmation": "Al actualizar esta plantilla de mensaje, todas las acciones de flujo automático que la utilicen también se actualizarán. Quiere proceder?"
        },
        "title": "Plantillas de mensajes",
        "whatsapp": {
          "name": "Nombre de la plantilla de WhatsApp",
          "tab": "WhatsApp",
          "title": "Plantillas de WhatsApp"
        }
      },
      "tokens": {
        "agency": {
          "description": "Nombre de la agencia",
          "title": "Nombre de la Agencia"
        },
        "agency_user": {
          "description": "Nombre del usuario de la agencia",
          "title": "Agencia Usuario"
        },
        "aspiring_minds_assessment_link": {
          "description": "Enlace personalizado a la evaluación de Aspiring Minds",
          "title": "Enlace de evaluación de aspirantes"
        },
        "aspiring_minds_login_link": {
          "description": "Enlace personalizado para iniciar sesión en Aspiring Minds",
          "title": "Enlace de inicio de sesión de Aspiring Minds"
        },
        "aspiring_minds_password": {
          "description": "Contraseña de Aspiring Minds",
          "title": "Contraseña de Aspiring Minds"
        },
        "aspiring_minds_svar_url": {
          "description": "Enlace personalizado a la evaluación SVAR de Aspiring Minds",
          "title": "Enlace de evaluación SVAR de Aspiring Minds"
        },
        "aspiring_minds_username": {
          "description": "Nombre de usuario de Aspiring Minds",
          "title": "Nombre de usuario de Aspiring Minds"
        },
        "assigned_recruiter": {
          "description": "Nombre completo del reclutador asignado",
          "title": "Reclutador asignado"
        },
        "assigned_recruiter_calendar_scheduler_url": {
          "description": "Enlace para agendar en el calendario del gerente asignado",
          "title": "Enlace del calendario del reclutador asignado"
        },
        "button": {
          "name": "Tokens"
        },
        "calendar_date": {
          "description": "Fecha de la cita de mi calendario",
          "title": "Fecha calendario"
        },
        "calendar_time_end": {
          "description": "Fin de la cita de mi calendario",
          "title": "Fin de la cita"
        },
        "calendar_time_start": {
          "description": "Inicio de la cita de mi calendario",
          "title": "Hora de inicio de la cita"
        },
        "call_center_agent_assessment_url": {
          "description": "Enlace personalizado a la evaluación SHL para agente de call center",
          "title": "URL de la evaluación del agente del call center de SHL"
        },
        "call_center_agent_secondary_assessment_url": {
          "description": "Enlace personalizado a la evaluación secundaria de SHL Call Center Agent",
          "title": "URL de evaluación secundaria del agente del centro de llamadas de SHL"
        },
        "candidate_first_name": {
          "description": "Primer nombre del Candidato",
          "title": "Primer Nombre del Candidato"
        },
        "candidate_id": {
          "description": "ID de la aplicación del candidato",
          "title": "Identificación del candidato"
        },
        "candidate_name": {
          "description": "Nombre completo del Candidato",
          "title": "Nombre del Candidato"
        },
        "channel_optin_url": {
          "description": "Enlace a la página de suscripción de WhatsApp",
          "title": "URL de suscripción de WhatsApp"
        },
        "chat_attachment": {
          "description": "ID de chat personalizado para solicitar archivos por Messenger",
          "title": "Archivo adjunto de chat"
        },
        "choose_position_link": {
          "description": "Enlace personalizado para mostrar vacantes en Messenger",
          "title": "Elegir enlace de posición"
        },
        "city": {
          "description": "Ubicación de la vacante de la campaña",
          "title": "Ciudad de campaña"
        },
        "company": {
          "description": "Nombre de su empresa",
          "title": "Compañía"
        },
        "emmersion_sign_in_url": {
          "description": "Enlace de inicio de sesión para evaluaciones de Emmersion",
          "title": "Enlace de Emmersion"
        },
        "erp_referrer_email": {
          "description": "Correo electrónico de la persona que remitió a un candidato",
          "title": "ERP Correo electrónico de referencia"
        },
        "erp_referrer_name": {
          "description": "Nombre de la persona que refirió a un candidato",
          "title": "ERP Nombre del remitente"
        },
        "harver_assessment_link": {
          "description": "Enlace directo para iniciar o reanudar la evaluación Harver asignada",
          "title": "Harver Assessment Link"
        },
        "hireiq_assessment_link": {
          "description": "Enlace personalizado para la evaluación de Hire IQ",
          "title": "Enlace de Hire IQ"
        },
        "hireiq_pin": {
          "description": "Número de PIN de Hire IQ",
          "title": "PIN de Hire IQ"
        },
        "insert_picture": {
          "description": "Inserta una imagen para enviarla por correo electrónico o Messenger",
          "title": "Insertar imagen"
        },
        "insert_video": {
          "description": "Inserte un video para enviarlo por correo electrónico o Messenger",
          "title": "Insertar video"
        },
        "interview_page_url": {
          "description": "Enlace personalizado al formulario de la página de destino",
          "title": "Enlace de Entrevista"
        },
        "interview_url": {
          "description": "URL personalizada al formulario de la página de destino",
          "title": "URL de la entrevista"
        },
        "job_landing_page_url": {
          "description": "Enlace a la página de descripción del trabajo",
          "title": "URL de la página de destino del trabajo"
        },
        "job_title": {
          "description": "Vacante a la cual el candidato aplicó",
          "title": "Posición"
        },
        "mail_attachment": {
          "description": "ID de correo electrónico personalizado para solicitar archivos por correo electrónico",
          "title": "Archivo adjunto de correo"
        },
        "messenger_call_to_action_link": {
          "description": "Enviar a Messenger",
          "title": "Enviar a Messenger"
        },
        "messenger_interview_link": {
          "description": "Enlace personalizado para desplegar las preguntas de la entrevista en Messenger",
          "title": "Link de messenger"
        },
        "messenger_interview_url": {
          "description": "URL personalizada para activar preguntas de entrevista en Messenger",
          "title": "URL de la entrevista de Messenger"
        },
        "my_calendar_scheduler_url": {
          "description": "Enlace a su calendario",
          "title": "Enlace de mi calendario"
        },
        "onboarding_form_url": {
          "description": "Enlace al formulario de incorporación en línea",
          "title": "Enlace del formulario de incorporación"
        },
        "onboarding_link": {
          "description": "Enlace al chatbot de incorporación",
          "title": "Enlace de inducción"
        },
        "pre_employment_chat_assessment_url": {
          "description": "Enlace personalizado a la evaluación SHL por chat",
          "title": "Enlace de la pre-evaluación SHL para el empleo por chat."
        },
        "reapply_retention_period": {
          "description": "Período de pausa de la campaña",
          "title": "Volver a aplicar el período de retención"
        },
        "recruiter_first_name": {
          "description": "Primer nombre del reclutador asignado",
          "title": "Nombre de Reclutador Asignado"
        },
        "recruitment_center_scheduler_url": {
          "description": "Enlace al calendario del centro de reclutamiento de la campaña",
          "title": "Programar a través del Centro de reclutamiento"
        },
        "referee": {
          "description": "Nombre de la persona que refirió a un candidato",
          "title": "Referido"
        },
        "referrer": {
          "description": "Nombre de la persona que refirió a un candidato",
          "title": "Nombre del remitente"
        },
        "referrer_employee_id": {
          "description": "ID de empleado de la persona que remitió a un candidato",
          "title": "ID de Empleado Referidor"
        },
        "rejected_reasons": {
          "description": "Razones para rechazar al candidato",
          "title": "Razones de rechazo"
        },
        "scheduled_at": {
          "description": "Fecha programada para la entrevista del candidato",
          "title": "Fecha Entrevista (Centro de Reclutamiento)"
        },
        "scheduled_at_recruiter_calendar": {
          "description": "Fecha programada para la entrevista del candidato",
          "title": "Fecha programada (Calendario del Reclutador)"
        },
        "scheduler_url": {
          "description": "Enlace al calendario del centro de reclutamiento de las campañas",
          "title": "Link para agendar cita"
        },
        "shortlisted_reasons": {
          "description": "Razones para preseleccionar al candidato",
          "title": "Razones de Preselección"
        },
        "site_location": {
          "description": "Sitio de la empresa o sucursal donde se asignará o capacitará a la nuevos contratados.",
          "title": "Ubicación"
        },
        "svar_spoken_english_assessment_url": {
          "description": "Enlace personalizado a la evaluación SVAR de Aspiring Minds",
          "title": "URL de evaluación de inglés hablado de SVAR"
        },
        "training_batch": {
          "description": "Grupo u ola de aprendices para su incorporación",
          "title": "Grupo de entrenamiento"
        },
        "training_date": {
          "description": "Fecha de la capacitación como parte de su incorporación",
          "title": "Fecha de entrenamiento"
        },
        "training_program": {
          "description": "Clase o programa de capacitación para su incorporación",
          "title": "Programa de Entrenamiento"
        },
        "training_time": {
          "description": "Tiempo de la capacitación para su incorporación",
          "title": "Tiempo de entrenamiento"
        },
        "training_venue": {
          "description": "Lugar de la capacitación para su incorporación",
          "title": "Lugar de entrenamiento"
        },
        "upcoming_scheduled_appointment": {
          "description": "La próxima fecha programada para la entrevista del candidato",
          "title": "Próxima cita programada"
        },
        "virtual_interview_link": {
          "description": "Enlace personalizado para participar en una entrevista virtual en directo",
          "title": "Enlace a la entrevista virtual"
        },
        "voice_ai_phone_call": {
          "description": "Enlace para que el candidato inicie una llamada telefónica de IA",
          "title": "Llamada Telefónica IA"
        },
        "voice_ai_web_call": {
          "description": "Enlace para que el candidato inicie una llamada web de IA",
          "title": "Llamada Web IA"
        },
        "whatsapp_call_to_action_link": {
          "description": "Enlace de llamada a la acción de WhatsApp",
          "title": "Enviar a WhatsApp"
        },
        "workday_candidate_id": {
          "description": "ID de candidato de Workday",
          "title": "ID de candidato de Workday"
        }
      }
    },
    "prompt": {
      "label": {
        "add_a_question": "Agregar pregunta",
        "create_new": "Crear nueva",
        "delete": "Eliminar",
        "question_set": {
          "name": "Nombre de Set de Preguntas",
          "search": "Buscar Set de Preguntas",
          "send": "Enviar Set de Preguntas"
        }
      },
      "text": {
        "created_by": "Creado por %{name} el %{date}",
        "edited_by": "Editado por %{name} el %{date}",
        "question_set": {
          "cannot_be_deleted": "Este Set de Preguntas no puede ser eliminado ya que se utiliza en un Flujo Automático en las siguientes Campañas:",
          "description": "Configure Sets de Preguntas a partir de Plantillas para ser utilizados con Flujos Automáticos y así enviar Preguntas de Seguimiento a Candidatos en cualquier momento de su proceso. ",
          "name_description": "Este nombre te ayudará a identificar el Set de Preguntas al configurar un Flujo Automático. Recomendamos que sea un nombre único y fácil de identificar. ",
          "restricted_prompts": "Sólo se muestran las preguntas de audio porque este conjunto se utiliza en un asistente de voz de IA",
          "smart_call_settings": "Este conjunto de preguntas sólo admite preguntas de audio, ya que se utiliza en los asistentes de voz de inteligencia artificial",
          "title": "Sets de Preguntas",
          "used_in_campaigns": "Este Set de Preguntas no puede ser eliminado ya que se utiliza en un Flujo Automático en las siguientes Campañas:"
        }
      }
    },
    "smart_call": {
      "landing_page": {
        "label": {
          "agent": "%{agent} está a punto de llamarte",
          "from": "desde %{number}",
          "get_ready": "¡Prepárate!",
          "greetings": "Hola, %{name}",
          "retrigger": {
            "button": "Comience la entrevista ahora",
            "title": "Si la llamada no comienza en 2 minutos, haga clic en el botón a continuación para activarla manualmente"
          },
          "tips": {
            "heads_up": "📝 Prepárate para hablar de tu experiencia y responder algunas preguntas.",
            "place": "📞 Permanece en un lugar tranquilo donde puedas concentrarte sin distracciones.",
            "signal": "🌐 Asegúrate de tener una señal telefónica fuerte para realizar llamadas fluidas.",
            "time": "⏰ Tener al menos 10 minutos disponibles para completar la llamada.",
            "title": "Consejos rápidos"
          }
        }
      },
      "setting": {
        "add": "AGREGAR nuevo asistente de IA",
        "ai_agents": "Llamadas de IA",
        "ai_agents_add": "AGREGAR nuevo asistente de IA",
        "ai_agents_description": "Integre AI Agents con Autoflow para automatizar las llamadas, creando experiencias atractivas que mejoren cada punto de contacto con su talento.",
        "create": {
          "action": "Crear agente",
          "click_here": "Haga clic aquí",
          "click_here_url": "https://help.talkpush.com/es",
          "description": "Por favor, introduzca el ID de la llamada de IA que desea integrar con Talkpush.",
          "error": "¡Ups! No pudimos reconocer ese ID. Por favor, vuelva a verificar e intente nuevamente.",
          "example": "por ejemplo, S1R2wOIovQnibnzRk8hCF7w",
          "identifier": "IA de Voz ID",
          "learn_more": "para aprender a encontrar el IA de Voz ID",
          "title": "Cree su agente"
        },
        "description": "Integre IA de Voz con Autoflow para automatizar las llamadas y crear experiencias de llamadas atractivas que mejoren cada punto de contacto con su talento.",
        "edit": {
          "form": {
            "ai_agent_configuration": {
              "description": "Configurar los ajustes de Voice AI",
              "title": "Configuración de llamadas de IA"
            },
            "ai_agent_details": {
              "add_voice_sample": "Añadir muestra de voz",
              "audio_file": "Archivo de audio (MP3), hasta 5 MB",
              "click_to_upload": "Haga clic para cargar o arrastre y suelte",
              "description": "Configurar los detalles de Voice AI",
              "title": "Detalles de Voice AI"
            },
            "audio_file_upload": {
              "description": "Cargar un archivo de audio para este Voice AI",
              "title": "Archivo de audio"
            },
            "available_prompt_sets": "Sólo se pueden seleccionar conjuntos con preguntas de sólo audio",
            "cancel": "Cancelar",
            "candidate_attribute": "Seleccionar atributo del candidato",
            "drag_drop_audio": "Arrastre y suelte aquí un archivo de audio, o haga clic para seleccionarlo",
            "drop_audio_here": "Suelte el archivo de audio aquí",
            "extracted_data_configuration": {
              "description": "Asignar los datos extraídos a los atributos candidatos",
              "title": "Configuración de los datos extraídos"
            },
            "prompt_set": "Seleccione un conjunto de preguntas",
            "save": "Guardar",
            "supported_formats": "Formatos compatibles MP3, WAV, M4A, OGG (máx. 50 MB)",
            "uploading_audio": "Cargando archivo de audio...",
            "value": "Ingrese el valor"
          },
          "input": {
            "description": "Complete el formulario a continuación para configurar la llamada IA de incorporación. La información que proporcione personalizará la llamada y garantizará que todos los participantes estén bien informados.",
            "title": "Configuración de llamadas de IA"
          },
          "language": "Idioma",
          "output": {
            "description": "Por favor, asigne cada información a extraer a un atributo candidato donde debe almacenarse.",
            "title": "Asignar datos extraídos a atributos de candidatos"
          },
          "persona": "Persona",
          "sync": "BUSCAR ACTUALIZACIONES",
          "sync_description": "Utilice esta función para sincronizar cualquier cambio realizado en su asistente de IA en la plataforma original, como actualizaciones de voz, idioma, escenarios o campos de datos para extraer.",
          "sync_modal": {
            "button": "SINCRONIZAR AHORA",
            "description": "¿Estás seguro de que deseas sincronizar el asistente de IA con las últimas actualizaciones de la plataforma original? Esta acción sobrescribirá cualquier cambio realizado en Talkpush.",
            "title": "Sincronizar el Asistente IA"
          },
          "title": "Editar la configuración de Voice AI",
          "toaster": {
            "error": "¡Ups! Algo salió mal. Por favor, inténtalo de nuevo.",
            "sync": "El asistente de IA se sincronizó correctamente.",
            "update": "La configuración de la llamada de IA se actualizó correctamente."
          }
        },
        "input": {
          "application_status": {
            "description": "Estado actual de la aplicación",
            "name": "Estado de la aplicación"
          },
          "available_interview_dates": {
            "description": "Listado de fechas disponibles para entrevistas.",
            "name": "Fechas de entrevistas disponibles"
          },
          "available_interview_times": {
            "description": "Listado de horarios disponibles para entrevistas.",
            "name": "Horarios de entrevistas disponibles"
          },
          "benefits_info": {
            "description": "Resumen de beneficios ofrecidos.",
            "name": "Información sobre beneficios"
          },
          "call_to_action": {
            "description": "Próximos pasos sugeridos para el candidato.",
            "name": "Llamado a la Acción"
          },
          "company_updates": {
            "description": "Noticias recientes o posiciones abiertas.",
            "name": "Actualizaciones de la empresa"
          },
          "contact_details": {
            "description": "Como los candidatos pueden comunicarse de vuelta",
            "name": "Detalles de Contacto"
          },
          "contact_email": {
            "description": "Correo electrónico de la persona de contacto.",
            "name": "Correo electrónico de contacto"
          },
          "contact_info": {
            "description": "Datos de contacto para consultas.",
            "name": "Información de contacto"
          },
          "contact_person": {
            "description": "Nombre del contacto del evento.",
            "name": "Persona de Contacto"
          },
          "contact_phone_number": {
            "description": "Número de teléfono de la persona de contacto.",
            "name": "Número de teléfono de contacto"
          },
          "documents_required": {
            "description": "Lista de documentos necesarios.",
            "name": "Documentos necesarios"
          },
          "event_date": {
            "description": "Fecha del evento.",
            "name": "Fecha del evento"
          },
          "event_description": {
            "description": "Resumen de detalles del evento.",
            "name": "Descripción del evento"
          },
          "event_location": {
            "description": "Datos del lugar o acceso.",
            "name": "Lugar del evento"
          },
          "event_name": {
            "description": "Nombre del evento.",
            "name": "Nombre del evento"
          },
          "event_reference": {
            "description": "Evento o proceso específico sobre el cual proporcionar retroalimentación.",
            "name": "Referencia de evento"
          },
          "event_time": {
            "description": "Hora del evento.",
            "name": "Hora del evento"
          },
          "feedback_provided": {
            "description": "Retroalimentación opcional para el candidato.",
            "name": "Retroalimentación proporcionada"
          },
          "feedback_questions": {
            "description": "Lista de preguntas para retroalimentación.",
            "name": "Preguntas de retroalimentación"
          },
          "first_day_schedule": {
            "description": "Agenda del primer día.",
            "name": "Horario del primer día"
          },
          "future_opportunities_info": {
            "description": "Información sobre futuras vacantes.",
            "name": "Información sobre oportunidades futuras"
          },
          "incentive_details": {
            "description": "Información sobre incentivos (opcional).",
            "name": "Detalles del incentivo"
          },
          "information": {
            "description": "Cualquier información que deba ser preguntada por la IA durante la llamada.",
            "name": "Información"
          },
          "interview_location": {
            "description": "La dirección o lugar donde se llevará a cabo la entrevista.",
            "name": "Lugar de la entrevista"
          },
          "interview_questions": {
            "description": "Lista de preguntas para hacer.",
            "name": "Preguntas de entrevista"
          },
          "interviewer_names": {
            "description": "Nombres de los entrevistadores.",
            "name": "Nombres de los entrevistadores"
          },
          "next_steps": {
            "description": "Qué debe esperar el candidato a continuación.",
            "name": "Próximos pasos"
          },
          "onboarding_location": {
            "description": "Lugar para actividades de incorporación.",
            "name": "Ubicación de la Incorporación"
          },
          "position_applied_for": {
            "description": "El puesto de trabajo para el cual el candidato aplicó.",
            "name": "Puesto solicitado"
          },
          "position_title": {
            "description": "El título del puesto de trabajo.",
            "name": "Título del Puesto"
          },
          "purpose": {
            "description": "El objetivo de la llamada.",
            "name": "Objetivo"
          },
          "rejection_reason": {
            "description": "Razón de rechazo",
            "name": "Razones de rechazo"
          },
          "special_instructions": {
            "description": "Información adicional para el candidato.",
            "name": "Instrucciones especiales"
          },
          "start_date": {
            "description": "Fecha de inicio propuesta para el puesto.",
            "name": "Fecha de inicio"
          },
          "start_time": {
            "description": "Información adicional sobre el estado.",
            "name": "Hora de inicio"
          },
          "status_details": {
            "description": "Información adicional sobre el estado.",
            "name": "Detalles del estado"
          },
          "submission_deadline": {
            "description": "Fecha límite para presentar los documentos.",
            "name": "Fecha límite de presentación"
          },
          "submission_method": {
            "description": "Cómo presentar los documentos.",
            "name": "Método de envío"
          }
        },
        "learn_more_url": "https://help.talkpush.com/es",
        "no_category": "Sin categoría",
        "pending_configuration": "Configuración pendiente",
        "phone_calls": "Llamadas telefónicas",
        "scenario": {
          "custom_calls": "Tipos de llamadas personalizados que puede personalizar para satisfacer necesidades específicas que se alinean con sus estrategias de reclutamiento y la cultura de la empresa.",
          "document_request": "Llamadas solicitando documentos o información adicional necesaria para avanzar en su solicitud, como portafolios, certificaciones o referencias, facilitando una evaluación completa.",
          "engagement_calls_for_passive_candidates": "Llamadas proactivas destinadas a fomentar la relación con candidatos pasivos informándoles sobre nuevas oportunidades, actualizaciones de la empresa o información de la industria para mantenerlos interesados.",
          "feedback_collection": "Llamadas diseñadas para recopilar comentarios de los candidatos sobre su experiencia de reclutamiento, proporcionando información valiosa para mejorar su proceso de contratación.",
          "interview": "Llamadas estructuradas que utilizan preguntas de entrevista predefinidas para evaluar de manera eficiente las calificaciones de los candidatos y al mismo tiempo garantizar la imparcialidad.",
          "job_fair_and_event_invitation": "Llamadas que invitan a los candidatos a próximos eventos de reclutamiento, seminarios web o ferias de empleo, destacando los beneficios de la asistencia y fomentando la participación.",
          "offer_extension": "Llamadas emocionantes para realizar una oferta de trabajo, describiendo detalles clave como salario, beneficios, fecha de inicio y próximos pasos, haciendo que el candidato se sienta valorado e informado.",
          "on_site_interview_invitation": "Llamadas personalizadas invitando a los candidatos a programar una entrevista en persona, confirmando los detalles de la cita y brindando información logística esencial para garantizar una experiencia fluida.",
          "onboarding_information": "Llamadas informativas que brindan a los nuevos empleados detalles esenciales de incorporación, incluidas instrucciones para el primer día, documentación requerida y cronogramas de orientación para garantizar una transición sin problemas.",
          "rejection_notification": "Llamadas respetuosas para informar a los candidatos que no fueron seleccionados, ofreciendo un cierre y posiblemente una breve retroalimentación para mantener una marca de empleador positiva.",
          "reminder": "Llamadas automatizadas de recordatorio sobre próximas entrevistas, evaluaciones o fechas límite para la presentación de documentos para mantener el proceso de reclutamiento en marcha.",
          "status_update": "Llamadas periódicas que proporcionan a los candidatos actualizaciones sobre el estado de su aplicación, garantizando que estén informados sobre su progreso y los próximos pasos en el proceso de reclutamiento."
        },
        "subtitle": "Conecta con candidatos al instante usando voz e inteligencia artificial",
        "talkscore_ai_interview": "Entrevista con TalkScore AI",
        "title": "Llamadas de IA"
      },
      "web_call": {
        "audio_devices": {
          "microphone": {
            "errors": {
              "no_microphone_selected": "No se ha seleccionado micrófono",
              "no_microphones_available": "No hay micrófonos disponibles"
            },
            "name": "Micrófono"
          },
          "speaker": {
            "default_system_device_name": "Bocina por defecto del sistema",
            "errors": {
              "no_speaker_selected": "No se ha seleccionado bocina",
              "no_speakers_available": "No hay bocinas disponibles"
            },
            "name": "Bocina"
          }
        },
        "branding": {
          "powered_by": "Desarrollado por"
        },
        "call_agent": {
          "mode": {
            "idle": "En espera",
            "listening": "Escuchando",
            "speaking": "Hablando"
          }
        },
        "call_feedback_screen": {
          "actions": {
            "submit": {
              "feedback": {
                "error": "No pudimos registrar tu evaluación. Por favor, inténtalo de nuevo.",
                "success": "Gracias por tus comentarios"
              },
              "title": "Enviar evaluación"
            }
          },
          "comments": {
            "description": "Comentarios, elogios, errores... ¡somos todo oídos!",
            "label": "¿Hay algo en lo que podamos mejorar?"
          },
          "message": "Nuestro equipo de contratación revisará tus respuestas y se pondrá en contacto en breve.",
          "rating": {
            "label": "Califica tu experiencia"
          },
          "title": "¡Todo está listo!"
        },
        "call_screen": {
          "audio_settings": {
            "microphone_volume_indicator": "Nivel de captura de entrada",
            "output_volume_control": "Volumen de bocina"
          },
          "call_controls": {
            "audio_settings": "Ajustes de audio",
            "end_call": "Finalizar llamada",
            "mute_microphone": "Silenciar micrófono",
            "unmute_microphone": "Activar micrófono"
          },
          "call_info": {
            "popover_anchor_label": "Información sobre la grabación"
          },
          "loading": {
            "title": "%{agent_name} se está preparando para tu entrevista.\nSólo tomará un momento...\n"
          },
          "network_connection_indicator": {
            "description": {
              "disconnected": "Perdiste la conexión a la red. Intentando reconectar.",
              "good": "Buena conexión. ¡Todo listo!",
              "unknown": "Este navegador no permite monitorear la conexión a la red.",
              "unstable": "Mala conexión. Intenta acercarte al router."
            },
            "popover_anchor_label": "Estado de la conexión a la red"
          }
        },
        "call_setup_screen": {
          "actions": {
            "setup_audio_devices": {
              "title": "Continuar"
            },
            "start_call": {
              "feedback": {
                "error": "No fue posible iniciar tu entrevista. Por favor, inténtalo de nuevo."
              },
              "title": "Iniciar entrevista"
            }
          },
          "audio_setup": {
            "description": "Asegurémonos de que podemos oírnos claramente antes de empezar.",
            "errors": {
              "denied_microphone_access": {
                "description": "No pudimos detectar tu micrófono. Conecta alguno o verifica los permisos de tu navegador para continuar.",
                "title": "Micrófono bloqueado"
              },
              "no_microphone_available": {
                "description": "No pudimos detectar tu micrófono. Conecta alguno para continuar con la entrevista.",
                "title": "No hay micrófono disponible"
              }
            },
            "test": "Probar",
            "title": "Verifica tus ajustes de audio"
          },
          "call_details": {
            "data_access_terms": {
              "description": "Esta entrevista nos ayuda a comprender mejor tu experiencia.",
              "title": "Revisado por nuestro equipo"
            },
            "duration": {
              "description": "Responderás a algunas preguntas a tu propio ritmo. No hay respuestas correctas o incorrectas; responde con naturalidad.",
              "title": "Conversación breve y guiada"
            },
            "media_requirements": {
              "description": "No hace falta cámara; sólo asegúrate de estar en un lugar silencioso.",
              "title": "Sólo audio"
            }
          },
          "description": "Te haremos algunas preguntas para comprender mejor tu experiencia y tu forma de responder a situaciones reales.",
          "devices_access_denied_modal": {
            "disclaimer": "El acceso al micrófono nos permite listar los micrófonos y bocinas conectados a tu dispositivo",
            "instructions": {
              "step_1": {
                "prefix": "1. Presiona el botón",
                "suffix": "en la barra de direcciones de tu navegador"
              },
              "step_2": "2. Concédenos acceso a tu micrófono para continuar."
            },
            "title": "Autorizar acceso al micrófono"
          },
          "greeting": "¡Preparémonos para la entrevista!"
        },
        "disclaimers": {
          "recording_notice": "Esta sesión se grabará con fines de evaluación y calidad."
        },
        "load_error_screen": {
          "actions": {
            "contact_support": {
              "email_template": {
                "body": "Hola,\n\nEstoy experimentando problemas para iniciar mi entrevista.\n\nEmpresa: %{company}\nID de llamada de entrevista: %{call_id}\n\nPor favor, ayúdenme a resolver esta situación.\n\nGracias.\n",
                "subject": "No puedo iniciar mi entrevista"
              },
              "title": "Contacta a nuestro equipo"
            },
            "retry_load": {
              "title": "Reintentar"
            }
          },
          "first_attempt": {
            "message": "Algo salió mal mientras preparábamos tu entrevista. No te preocupes, tu aplicación está a salvo. Intentémoslo de nuevo.",
            "title": "No pudimos obtener los detalles de tu entrevista"
          },
          "second_attempt": {
            "message": "No fue posible obtener la información de tu entrevista. No te preocupes, tu aplicación sigue a salvo. Inténtalo de nuevo en unos minutos o contacta a nuestro equipo de reclutamiento.",
            "title": "No pudimos establecer conexión"
          }
        },
        "loading_screen": {
          "title": "Preparando la entrevista"
        }
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "Correo electrónico",
        "first_name": "Nombre",
        "last_name": "Apellidos",
        "new_recording": "Nueva grabación",
        "phone_number": "Número de teléfono",
        "record_now": "Grabar ahora",
        "start_camera": "Iniciar Cámara",
        "stop_recording": "Para de grabar",
        "take_picture": "Toma una foto"
      },
      "notes": {
        "video_limit": "La duración máxima de la respuesta de video es de 1 minuto."
      },
      "show": {
        "about": "Acerca de"
      },
      "success": {
        "answers_message": "Gracias por enviar sus respuestas. Hemos recibido su aplicación.",
        "title": "Gracias"
      }
    }
  },
  "helpers": {
    "nav": {
      "campaigns": "Campañas"
    },
    "select": {
      "prompt": "Por favor seleccione"
    },
    "submit": {
      "create": "Crear %{model}",
      "submit": "Guardar %{model}",
      "update": "Actualizar %{model}"
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Añadir imagen",
      "apply": "Aplicar",
      "change_image": "Cambiar imagen",
      "save": "Guardar",
      "select_page_helper": "Ligar una o más páginas de Facebook significa que cualquiera que hable con su bot puede ver esta campaña. Para que esta campaña no aparezca en el chatbot, deje este campo vacío.",
      "view_job_description": "Ver descripción"
    },
    "google": {
      "google_job": "Google Jobs (beta)",
      "job_par": {
        "best_practice": "mejores prácticas",
        "first": "Las posiciones que se indicen en Google aparecerán directamente en los resultados de búsqueda de Google.",
        "head": "Habilitar que Google indice el Landing Page",
        "help_center": "nuestro centro de ayuda",
        "second": "Los aplicantes que accedan a estos resultados en Google serán redirigidos al Landing page de Talkpush, donde pueden aplicar y completar inmediatamente las preguntas iniciales. Puede aprender más al respecto en",
        "third": "Si su puesto de trabajo no aparece en las publicaciones de Google Job, por favor asegúrese de seguir estas"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Require que se completen la posición, el país, y la descripción larga de la posición."
      }
    },
    "landing": {
      "copy": "Copiar",
      "first": "URL del Landing Page",
      "save": "Guardar"
    },
    "tecoloco": {
      "job_par": {
        "first": "Los trabajos que se enumeran en Tecoloco aparecerán enlos resultados de búsqueda de Tecoloco.",
        "head": "Anunciar este puesto de trabajo en Tecoloco",
        "help_center": "nuestro centro de ayuda",
        "second": "Los candidatos que se postulan para estas posiciones de trabajo son redirigidos a la página de Talkpush, donde pueden postularse y completar de inmediato las preguntas de selección. Puede obtener más información al respecto en"
      },
      "tecoloco_jobs": "Empleos en Tecoloco"
    }
  },
  "job_landing_page": {
    "application_invalid": "Aplicación inválida"
  },
  "jobs": {
    "salary_types": {
      "annually": "Anual",
      "biweekly": "Quincenal",
      "daily": "Diariamente",
      "hourly": "Por hora\n",
      "monthly": "Mensual",
      "one-time": "Una vez",
      "weekly": "Semanal"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "mil millones",
          "million": "Millón",
          "quadrillion": "mil billones",
          "thousand": "mil",
          "trillion": "Trillón",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n %",
        "precision": 1
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy-applicant/",
  "setup_questions": {
    "onboarding_title": "Preguntas de inducción",
    "question_types": {
      "audio": "Audio",
      "text": "Texto"
    },
    "update": "Actualizar"
  },
  "time": {
    "am": "am",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%A, %-d de %B de %Y %H:%M:%S %z",
      "long": "%-d de %B de %Y %H:%M",
      "short": "%-d de %b %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "minute": "1 minuto",
    "minutes": "%{minutes} minutos",
    "pm": "pm",
    "second": "1 segundo",
    "seconds": "%{seconds} segundos",
    "time_left": "Tiempo restante: %{minutes} %{seconds}"
  }
});

window.t = I18n.t.bind(I18n);
window.l = I18n.l.bind(I18n);
I18n.locale = document.documentElement.lang;
